{
  "common": {
    "productNoun": {
      "form": "modulo",
      "survey": "sondaggio",
      "quiz": "quiz"
    },
    "productNounCapitalized": {
      "form": "Modulo",
      "survey": "Sondaggio",
      "quiz": "Quiz"
    },
    "urlField": {
      "settingsTitle": "Definisci le impostazioni del campo URL",
      "description": "Seleziona i tipi di URL consentiti per questo campo.",
      "allowAllDomains": "Consenta tutti i domini",
      "allowAllDomainsDescription": "È accettato qualsiasi URL valido.",
      "allowOnlyDomains": "Consenti solo questi domini",
      "allowOnlyDomainsDescription": "Tutto il resto viene rifiutato.",
      "blockDomains": "Blocca questi domini",
      "blockDomainsDescription": "Tutto il resto è accettato.",
      "domainsAllowed": "Domini autorizzati",
      "domainsBlocked": "Domini bloccati",
      "domainPlaceholder": "ad es., example.com",
      "domainPlaceholderAdd": "Aggiungine un altro",
      "domainHint": "Digita un dominio e premi Invio per aggiungerlo.",
      "invalidDomain": "Inserisci un dominio valido senza http://, https:// o un percorso.",
      "domainRequired": "Aggiungi almeno un dominio per questa opzione.",
      "singleUrlInfo": "È supportato un solo URL per campo. Per acquisire più URL, crea dei campi separati."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "secondi",
    "other": "-- Altro --",
    "customFieldExistsError": "Personalizzato Campo con questo nome esiste già",
    "requiredField": "Questo campo è obbligatorio",
    "uniqueKeyNotUniqueError": "Questa Chiave non è l'unica",
    "save": "Salva",
    "saving": "Salvataggio",
    "typeAnOption": "Digita un'opzione",
    "unsaved": "Non salvato",
    "noSubmissionsFound": "Nessun invio trovato",
    "sortBy": "Ordina per",
    "clearAll": "Rimuovi tutto",
    "submitSurvey": "Invia sondaggio",
    "select": "Seleziona",
    "data": "Dati",
    "enterAmount": "Inserisci importo",
    "disqualifyAfterSubmitLower": "Squalifica dopo l'invio",
    "errorRetryAgain": "Errore, riprova di nuovo",
    "savedSuccessfully": "Salvato con successo!",
    "couldntSaveChanges": "Impossibile salvare le modifiche. Riprova.",
    "emailNotificationSettingsUpdated": "Le impostazioni di notifica email sono state aggiornate.",
    "autoResponderSettingsUpdated": "Le impostazioni del risponditore automatico sono state aggiornate.",
    "bubbleRadioStyleImageAlt": "Stile radio bubble",
    "standardRadioStyleImageAlt": "Stile radio standard",
    "recurringFrequency": {
      "once": "Una volta",
      "daily": "Quotidiano",
      "weekly": "Settimanale",
      "monthly": "Mensile",
      "yearly": "Annuale"
    },
    "saveExitConfirmationSubText": "Mostra una finestra di conferma quando l'utente esce dalla pagina.",
    "yes": "Sì",
    "no": "No",
    "updated": "Aggiornato",
    "new": "Nuovo",
    "title": "Titolo",
    "openSettings": "Apri le impostazioni",
    "cloneField": "Clona campo",
    "removeField": "Rimuovi campo",
    "description": "Descrizione",
    "cannotAddThisField": "Questo campo non può essere aggiunto.",
    "cannotAddThisFieldSubheading": "Questo {product} utilizza già {existing} campi. Rimuovi tutti i campi da 1 oggetto prima di aggiungere {attempted} campi.",
    "overallOnly": "Solo complessivo",
    "nextSlideDefault": "Diapositiva successiva (Predefinita)",
    "nextQuestion": "Domanda successiva",
    "searchAddress": "Cerca indirizzo",
    "recurringDonation": "Donazione Ricorrente",
    "recurringDonationDay": "Donazione ricorrente 1 giorno",
    "recurringDonationWeek": "Donazione ricorrente settimanale 1",
    "recurringDonationMonth": "Donazione ricorrente 1 mese",
    "recurringDonationYear": "Donazione ricorrente di 1 anno",
    "integrate": "Integra",
    "share": "Condividi",
    "email": "Email",
    "connections": "Collegamenti",
    "comingSoon": "Prossimamente",
    "newWorkflow": "Nuovo flusso di lavoro",
    "workflow": "Flusso di lavoro",
    "funnel": "Funnel",
    "website": "Sito web",
    "notConnectedToWorkflow": "Questo {asset} non è ancora connesso al flusso di lavoro",
    "workflowEmptyDescription": "Invia un'email di conferma, avvisa il tuo team o assegna automaticamente un tag ai nuovi lead quando qualcuno invia questo {asset}.",
    "workflowName": "Nome flusso di lavoro",
    "workflowStatus": "Stato",
    "workflowLastUpdated": "Ultimo aggiornamento",
    "workflowStatusPublished": "Pubblicato",
    "workflowStatusDraft": "Bozza",
    "openInNewTab": "Apri in una nuova scheda",
    "moreActions": "Altre azioni",
    "rename": "Rinomina",
    "workflowsShowingFirst": "Visualizzazione dei primi {count} flussi di lavoro",
    "retry": "Riprova",
    "workflowsLoadError": "Impossibile caricare i workflow collegati.",
    "renameWorkflow": {
      "title": "Rinomina flusso di lavoro",
      "description": "Dai a questo flusso di lavoro un nome che ti dica cosa fa.",
      "nameLabel": "Nome",
      "namePlaceholder": "Inserisci il nome del flusso di lavoro",
      "nameRequired": "Il nome del flusso di lavoro è obbligatorio"
    },
    "deleteWorkflow": {
      "title": "Elimina flusso di lavoro",
      "confirmDescription": "Vuoi davvero eliminare \"{name}\"? Una volta eliminato, verrà spostato nella scheda \"Eliminato\" e sarà rimosso definitivamente dopo 30 giorni."
    },
    "workflowRenamed": {
      "title": "Flusso di lavoro rinominato",
      "description": "Questo flusso di lavoro ora si chiama \"{name}\"."
    },
    "workflowDeleted": {
      "title": "Flusso di lavoro eliminato",
      "description": "\"{name}\" è stato eliminato."
    },
    "workflowRenameFailed": {
      "title": "Impossibile rinominare il flusso di lavoro",
      "description": "Riprova più tardi."
    },
    "workflowDeleteFailed": {
      "title": "Eliminazione del flusso di lavoro non riuscita",
      "description": "Riprova più tardi."
    },
    "exampleDomain": "example.com",
    "preview": "Anteprima",
    "back": "Indietro",
    "close": "Chiudi",
    "goHighLevel": "GoHighLevel",
    "openMediaLibrary": "Apri la libreria multimediale",
    "alert": "Avviso",
    "proceed": "Procedi",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "delete": "Elimina",
    "embed": "Incorpora",
    "link": "Link",
    "linkModal": {
      "title": "Inserisci link",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.esempio.com",
      "invalidUrl": "L'URL non è valido"
    },
    "iframeEmbed": "Incorporamento Iframe",
    "styles": "Stili",
    "options": "Opzioni",
    "quickAdd": "Aggiunta rapida",
    "customFields": "Campi personalizzati",
    "addObjectFields": "Aggiungi campi oggetto",
    "personalInfo": "Informazioni personali",
    "contactInfo": "Informazioni di contatto",
    "submit": "Invia",
    "address": "Indirizzo",
    "customized": "Personalizzato",
    "layout": "Layout",
    "showLabel": "Mostra etichetta",
    "showImage": "Mostra immagine",
    "imageLayout": "Allineamento dei contenuti dell'immagine",
    "imageLayoutSettings": "Impostazioni layout immagine",
    "imageLayoutMode": "Modalità di allineamento dei contenuti immagine",
    "surveyDefault": "Impostazione predefinita del sondaggio",
    "independent": "Indipendente",
    "image": "Immagine",
    "desktop": "Desktop",
    "mobile": "Mobile",
    "desktopImage": "Immagine Desktop",
    "mobileImage": "Immagine Mobile",
    "uploaded": "Caricato",
    "changeImage": "Cambia immagine",
    "uploadImage": "Carica immagine",
    "remove": "Rimuovi",
    "background": "Sfondo",
    "buttonBackground": "Sfondo Pulsante",
    "gradient": "Gradiente",
    "type": "Tipo",
    "linear": "Lineare",
    "radial": "Radiale",
    "angular": "Angolare",
    "angle": "Angolo",
    "stops": "Fermate",
    "startColor": "Colore iniziale",
    "endColor": "Colore finale",
    "addColor": "Aggiungi colore",
    "fontColour": "Colore Carattere",
    "textFontColour": "Colore del carattere del testo",
    "subTextFontColour": "Colore del carattere del testo secondario",
    "selectThemes": "Seleziona Tema",
    "selectOne": "Seleziona uno",
    "enableIcon": "Abilita icona",
    "iconType": "Tipo di icona",
    "iconPlacement": "Posizionamento delle Icone",
    "filled": "Compilato",
    "textOnly": "Solo corpo",
    "border": "Bordo",
    "borderType": "Tipo di bordo",
    "cornerRadius": "Raggio d'angolo",
    "width": "Larghezza",
    "padding": "Spaziatura interna",
    "top": "Superiore",
    "bottom": "Inferiore",
    "left": "Sinistra",
    "right": "Destra",
    "center": "Centro",
    "default": "Predefinito",
    "formDefault": "Predefinito modulo",
    "shadow": "Ombra",
    "color": "Colore",
    "horizontal": "Orizzontale",
    "vertical": "Verticale",
    "blur": "Sfocatura",
    "spread": "Diffondi",
    "fieldStyle": "Stile del campo",
    "fontColor": "Colore del carattere",
    "inputTextFillColor": "Colore di riempimento del testo di input",
    "inputTextColor": "Colore del testo di input",
    "primaryColor": "Colore primario",
    "primaryColorTooltip": "Controlla il Colore per lo stato al passaggio del mouse e lo stato Dinamico.",
    "primaryColorTooltipLearnMore": "Scopri di più",
    "inputTextColorTooltip": "Controlla il Colore del Testo digitato nei campi di feedback.",
    "mapPrimaryColorToButtonColor": "Mappa il colore primario al colore del pulsante",
    "label": "Etichetta",
    "fontFamily": "Famiglia di caratteri",
    "size": "Dimensione",
    "weight": "Peso",
    "fontWeightTooltip": "Applicabile nel caso di paragrafi",
    "fontWeightOptions": {
      "thin": "100 - Sottile",
      "extraLight": "200 - Extra Light",
      "light": "300 - Leggero",
      "normal": "400 - Normale",
      "medium": "500 - Medio",
      "semiBold": "600 - Semigrassetto",
      "bold": "700 - Grassetto"
    },
    "placeholder": "Segnaposto",
    "customCSS": "CSS personalizzato",
    "backgroundImage": "Immagine di sfondo",
    "headerImage": "Immagine dell'intestazione",
    "miscellaneous": "Varie",
    "agencyBranding": "Branding dell'agenzia",
    "imageUploadMessage": "Fai clic su un file immagine o trascinalo in quest'area per caricarlo",
    "backgroundImageTooltipMessage": "L'immagine di sfondo deve coprire l'intera pagina, fornendo uno sfondo visivamente accattivante per il modulo. Per visualizzare l'immagine di sfondo, fai clic sull'opzione Anteprima.",
    "headerImageTooltipMessage": "L'immagine dell'intestazione è progettata per coprire l'intera larghezza del modulo e rimane posizionata nella parte superiore del modulo. Per visualizzare l'immagine dell'intestazione, fai clic sull'opzione Anteprima.",
    "onSubmit": "All'invio",
    "facebookPixelID": "ID pixel di Facebook",
    "facebookPixelFunnelLabel": "Utilizza questo all'interno di un funnel?",
    "facebookPixelFunnelText": "Lascia il campo vuoto — subentrano il Pixel e le impostazioni del consenso ai cookie del funnel.",
    "facebookPixelEmbedLabel": "Incorporamento su un altro sito?",
    "facebookPixelEmbedText": "Scegli come viene gestito il consenso ai cookie nel passaggio del codice di incorporamento.",
    "facebookPixelConsentCallout": "Il consenso ai cookie viene impostato per ogni incorporamento, in",
    "facebookPixelConsentCalloutLink": "Integra → Codice di incorporamento",
    "facebookPixelEvents": "Eventi del pixel di Facebook",
    "onpageView": "Visualizzazione sulla pagina",
    "stickyContact": "Contatto frequente",
    "stickyContactMessage": "Memorizza e compila automaticamente i dettagli di contatto quando l'utente ritorna sullo stesso dispositivo e browser.",
    "generateSubmissionDocument": "Genera un documento di invio",
    "generateSubmissionDocumentMessage": "Crea automaticamente un PDF stampabile di ogni invio e allegalo ai documenti del contatto",
    "saveQuizSubmissionAsPdf": "Salva l'invio del quiz come PDF",
    "saveQuizResultAsPdf": "Salva il risultato del quiz come PDF",
    "showSubmissionInConversationsFeed": "Crea una conversazione al momento dell'invio",
    "showSubmissionInConversationsFeedMessage": "Crea automaticamente un thread di conversazione quando questo modulo viene inviato; ciò ti permette di inviare un follow-up tramite email, SMS o altri canali nella scheda Conversazioni.",
    "fieldDescription": "Descrizione del campo",
    "fieldTitle": "Titolo del campo",
    "queryKey": "Chiave della query",
    "querykeyTooltipMessage": "La chiave della query che può essere usata come parametro dell'URL per popolare questo campo",
    "required": "Obbligatorio",
    "hidden": "Nascosto",
    "hiddenValue": "Valore nascosto",
    "enableCountryPicker": "Abilita selettore di paese",
    "altText": "Testo alternativo",
    "optionImageAlt": "Immagine opzione",
    "bannerAlt": "banner",
    "avatarAlt": "Nome avatar",
    "alignment": "Allineamento",
    "imageWidth": "Larghezza dell'immagine",
    "imageHeight": "Altezza dell'immagine",
    "logic": "Logica",
    "pleaseInput": "Inserisci",
    "editHTML": "Modifica HTML",
    "textStyle": "Stile del testo",
    "subText": "Testo secondario",
    "text": "Testo",
    "buttonStyle": "Stile del pulsante",
    "fullWidth": "Larghezza completa",
    "htmlMessage": "L'HTML personalizzato va qui",
    "htmlEditorHeader": "JAVASCRIPT / HTML PERSONALIZZATO",
    "htmlEditorBodyMessage": "Aggiungi qui il tuo codice",
    "scriptAdded": "Script aggiunto!",
    "sourceAddedForm": "Fonte \"Nome del modulo\"",
    "sourceAddedSurvey": "Fonte \"Nome del sondaggio\"",
    "sourceAddedQuiz": "Fonte \"Nome del quiz\"",
    "yesSave": "Sì, salva",
    "cancelKeep": "Annulla, mantieni",
    "done": "Fatto",
    "addElement": "Aggiungi elemento",
    "addUrlLike": "Inserisci URL validi, come ad esempio",
    "doNotAddRelativePath": "Non aggiungere percorsi relativi come",
    "or": "o",
    "addCustomFields": "Aggiungi campi personalizzati",
    "customFieldSearch": "Cerca per nome",
    "selectedCount": "Selezionati: {count}",
    "noFieldsFound": "Nessun campo trovato",
    "noFieldsMatchQuery": "Non c'è nessun campo corrispondente a \"{query}\". Prova un termine diverso o crea un nuovo campo.",
    "clearSearch": "Cancella ricerca",
    "addFieldWithCount": "Aggiungi {count} campo | Aggiungi {count} campi",
    "noFieldsYet": "Non ci sono ancora campi",
    "noFieldsForObject": "Questo oggetto non ha ancora alcun campo. Creane uno per iniziare.",
    "createField": "Crea campo",
    "enterSourceValue": "Inserisci il valore della fonte",
    "shortLabel": "Etichetta breve",
    "shortLabelPlaceholder": "Carattere a Etichetta breve",
    "labelPlaceholder": "Digita un'etichetta",
    "imagePlaceholder": "Immagine",
    "fillValuesPlaceholder": "Aggiungi valori",
    "customCSSTooltip": "Il CSS personalizzato ha la precedenza sullo stile dei moduli e sui temi e può avere un impatto sullo stile del tema.",
    "fontFamilyTooltip": "Builder supporta tutti i tipi di font, se non lo vedi nell'elenco. Cercalo nel menu a discesa",
    "angleTooltip": "Controlla la direzione del gradiente. 0° è a destra, 90° è in basso, 180° è a sinistra, 270° è in alto.",
    "useGDPRCompliantFont": "Usa carattere conforme al GDPR",
    "enableTimezone": "Abilita fuso orario",
    "inputStyle": "Stile di inserimento",
    "conditionalLogicAlertOnSubmit": "La logica condizionale avrà la precedenza sul messaggio/reindirizzamento",
    "conditionalLogicAlertOnShowHide": "La logica condizionale avrà la precedenza sulle impostazioni nascoste",
    "placeholderFacebookPixelIdInput": "Inserisci l'ID pixel di Facebook",
    "doNotShowMessage": "Non mostrare più",
    "creatingForm": "Crea il tuo modulo...",
    "creatingSurvey": "Crea il tuo Sondaggio...",
    "creatingQuiz": "Crea il tuo quiz...",
    "errorCreatingForm": "Lì è stato un errore Crea il tuo Modulo. Riprova.",
    "errorCreatingSurvey": "Lì è stato un errore Crea il tuo Sondaggio. Riprova.",
    "errorCreatingQuiz": "Lì è stato un errore Crea il tuo quiz. Riprova.",
    "redirectMessage": "Ti reindirizzeremo a:",
    "themes": {
      "themes": "Temi",
      "alertThemeMessage": "Il cambio di tema comporterà la perdita di tutte le modifiche di stile attuali.",
      "useTheme": "Utilizza il tema",
      "removeTheme": "Rimuovi il tema"
    },
    "box": "Casella",
    "line": "Linea",
    "message": "Messaggio",
    "openUrl": "Reindirizza all'URL",
    "borderTypeList": {
      "dotted": "Punteggiato",
      "dashed": "Tratteggiato",
      "solid": "Uniforme",
      "none": "Nessuno"
    },
    "button": "Pulsante",
    "emailNotification": "Notifiche email",
    "emailNotificationSubheader": "Ricevi un'e-mail quando qualcuno compila il tuo modulo",
    "subject": "Oggetto",
    "emailTo": "Email (a)",
    "senderName": "Nome del mittente",
    "senderNameWarning": "Il tuo (nome del sottoaccount) verrà aggiunto se lasciato vuoto",
    "emailError": "È richiesto almeno un indirizzo email",
    "emailTooltip": "Inserisci uno o più indirizzi email che dovrebbero ricevere un avviso per l'invio del modulo. Il primo indirizzo va nel campo \"A\"; gli altri vengono inseriti in \"CC\".",
    "emailTooltipForm": "Inserisci uno o più indirizzi email che dovrebbero ricevere un avviso per l'invio del modulo. Il primo indirizzo va nel campo \"A\"; gli altri vengono inseriti in \"CC\".",
    "emailTooltipSurvey": "Inserisci uno o più indirizzi email che dovrebbero ricevere un avviso per l'invio del modulo. Il primo indirizzo va nel campo \"A\"; gli altri vengono inseriti in \"CC\".",
    "emailTooltipQuiz": "Inserisci uno o più indirizzi email che dovrebbero ricevere un avviso per l'invio del quiz. Il primo indirizzo va nel campo \"A\"; gli altri vengono inseriti in \"CC\".",
    "clear": "Rimuovi",
    "filter": "Filtra",
    "noResults": "Nessun risultato",
    "search": "Cerca",
    "showNotificationsSettings": "Mostra impostazioni delle notifiche",
    "emailServicePaid": "Questa funzionalità è un servizio a pagamento e comporterà costi in base all'utilizzo.",
    "integration": "Integrazione",
    "validation": {
      "fieldRequired": "Campo è Obbligatorio",
      "maxLengthExceeded": "Massimo Lunghezza ha superato ({max} Carattere)"
    },
    "securityValidation": {
      "title": "Problemi di sicurezza individuati. Non sono consentiti i seguenti elementi:",
      "cookieAccess": "Rilevato accesso ai cookie (document.cookie). Per motivi di sicurezza, questo non è consentito.",
      "storageAccess": "localStorage.getItem() - la lettura da localStorage non è permessa.",
      "evalUsage": "L'uso di eval() non è consentito in quanto può eseguire codice arbitrario.",
      "dynamicFunction": "La creazione dinamica di funzioni (new Function) non è consentita per motivi di sicurezza.",
      "stringExecution": "Il passaggio di stringhe a setTimeout/setInterval non è consentito poiché può eseguire codice arbitrario. Usa invece riferimenti di funzione.",
      "unclosedTag": "Rilevato tag HTML non chiuso (ad esempio un <style> senza il relativo </style> di chiusura). Chiudi tutti i tag prima di salvare, altrimenti la pagina pubblicata potrebbe non essere caricata."
    },
    "products": {
      "subscriptionBadge": "Abbonamento",
      "trialBadge": "Prova gratuita di {days} giorno",
      "setupFee": "Costo di configurazione una tantum",
      "quantity": "Quantità",
      "productImageAlt": "Immagine prodotto",
      "bumpIconAlt": "Icona opzione aggiuntiva"
    },
    "payment": {
      "payments": "Pagamenti",
      "paymentProviders": "Fornitori di servizi di pagamento",
      "paymentProvidersDescription": "Collega un fornitore di pagamento per iniziare ad accettare pagamenti.",
      "connectedProviders": "Fornitori connessi",
      "requireCreditCard": "Richiedi la carta per ordini pari a 0 $",
      "requireCreditCardTooltip": "Quando l'opzione è abilitata, i clienti devono inserire una carta di credito anche per gli acquisti pari a 0 $.",
      "connectProviders": "Collega i fornitori",
      "loading": "Caricamento in corso...",
      "generalTab": "Generale",
      "productTab": "Prodotto",
      "connected": "Collegato",
      "connect": "Collega",
      "liveModeOn": "Modalità live",
      "status": "Stato",
      "test": "Test",
      "live": "Live",
      "paymentFields": "Campi di pagamento",
      "suggestAnAmount": "Suggerisci un importo",
      "recurringPayments": "Pagamenti Ricorrenti",
      "selectCurrency": "Seleziona la valuta",
      "tagActiveBGColor": "Colore etichetta attiva",
      "includeOtherAmount": "Includi altro importo",
      "footerInfo": "Info piè di pagina",
      "paymentType": "Tipo di pagamento",
      "sellProducts": "Vendi prodotti",
      "customAmount": "Importo personalizzato",
      "collectPayment": "Raccogli pagamento",
      "generalSettings": "Campi generali",
      "securePayments": "*Blocca al 100% e pagamenti sicuri*",
      "error": {
        "addMainProductFirst": "Aggiungi prima un PRIMARIO Prodotto",
        "priceNotFoundForBumpProduct": "Prezzo non trovato per il Prodotto aggiuntivo",
        "productAlreadyAdded": "Prodotto già aggiunto"
      },
      "product": {
        "addProduct": "Aggiungi prodotto",
        "productSettings": "Impostazioni prodotto",
        "bumpTag": "Opzione aggiuntiva",
        "settingsAria": "Impostazioni prodotto",
        "deleteAria": "Elimina prodotto",
        "selectProduct": "Seleziona prodotto",
        "editThisProduct": "Per modificare questo prodotto",
        "clickHere": "Fai clic qui",
        "show": "Mostra",
        "description": "Descrizione",
        "image": "Immagine",
        "layoutSettings": "Impostazioni di layout",
        "singleColumn": "Colonna singola",
        "twoColumn": "Due colonne",
        "threeColumn": "Tre colonne",
        "maxProductError": "In un modulo sono consentiti al massimo 20 prodotti",
        "productSelectPlaceholder": "Seleziona un prodotto",
        "orderConfirmation": "Conferma dell'ordine",
        "orderConfirmationWarning": "Una volta che il pagamento è andato a buon fine, verrà visualizzata una pagina di conferma dell'ordine",
        "quantity": "Quantità",
        "createProduct": "Per creare un prodotto",
        "noProductsAdded": "Nessun prodotto ancora aggiunto",
        "productsWillShowHere": "Una volta che i prodotti Tu Includi, mostreranno Destra qui",
        "chooseProductType": "Seleziona prodotto digitale",
        "mainProduct": "PRIMARIO Prodotto",
        "primaryOffer": "Offerta primaria",
        "checkoutAddOn": "Componente aggiuntivo di checkout",
        "pricingOptions": "Opzioni di prezzo",
        "pricingOptionsPlaceholder": "Seleziona le opzioni di prezzo (predefinito: tutte)",
        "all": "TUTTO",
        "addOrSelectProducts": "Aggiungi o seleziona prodotti",
        "onceYouAddProductsTheyWillShowUpRightHere": "Una volta aggiunti i prodotti, verranno visualizzati proprio qui",
        "addProducts": "Aggiungi prodotti"
      },
      "bumProduct": {
        "price": "Prezzo",
        "variant": "Variante",
        "headline": "Titolo",
        "otoHeadline": "Titolo OTO",
        "otoText": "OTO Corpo",
        "enableImage": "Abilita Immagine",
        "imageMessage": "Afferriamo il Predefinito Prodotto Immagine",
        "orUploadADifferentImage": "O Carica a different Immagine",
        "bumpProducts": "Prodotti aggiuntivi",
        "bumpProduct": "Prodotto aggiuntivo",
        "enableBump": "Abilita urto",
        "orderBumpStyle": "Offerta aggiuntiva Stile aggiuntivo",
        "classic": "Classico",
        "modern": "Moderno",
        "icon": "Icona",
        "bumpTemplate": "Seleziona Modello",
        "highlightText": "Evidenzia Corpo",
        "showPrice": "Mostra Prezzo",
        "bumpPriceColor": "Prezzo aggiuntivo",
        "bumpIconColor": "Icona di urto",
        "bumpBackgroundColor": "Sfondo a Sfondo",
        "highlightTextColor": "Evidenzia Corpo",
        "headlineColor": "Titolo",
        "otoHeadlineColor": "Titolo OTO",
        "otoTextColor": "OTO Corpo",
        "bumpBorderColor": "Bordo a Bordo",
        "priceRequired": "Il prezzo è obbligatorio",
        "headlineRequired": "Il titolo è Obbligatorio",
        "otoHeadlineRequired": "Il titolo dell'offerta una tantum è obbligatorio",
        "otoTextRequired": "Il testo dell'offerta una tantum è obbligatorio",
        "bumpProductTooltip": "Un Piccolo Componente aggiuntivo offerto durante Pagamento a Moltiplica Ordina Valore. I Clienti possono includerlo con un Individuo fai clic.",
        "templateOne": "Modello 1",
        "templateTwo": "Modello 2",
        "templateThree": "Modello 3",
        "animationIcon": {
          "none": "Nessuno",
          "arrow": "Freccia",
          "fire": "Fuoco",
          "plus": "Più",
          "giftBox": "Casella regalo",
          "timer": "Conto alla rovescia",
          "cracker": "Cracker",
          "snack": "Spuntino",
          "partyBalloon": "Palloncino per feste",
          "flash": "Flash",
          "money": "Valuta",
          "spaceShuttle": "Navetta Spazio"
        }
      },
      "coupons": {
        "coupons": "Coupon",
        "enableCoupon": "Abilita coupon",
        "couponAlignment": "Allineamento del coupon",
        "left": "Sinistra",
        "right": "Destra",
        "fullWidth": "Larghezza completa",
        "tooltipMessage": "Imposta la posizione di inserimento del coupon dai tipi sottostanti"
      }
    },
    "sellProductsAddress": {
      "shippingAddressDescription": "Utilizza l'elemento Indirizzo per calcolare le tasse in base all'indirizzo del cliente.",
      "billingAddress": "Indirizzo di fatturazione",
      "billingRequiresAddress": "Aggiungi un elemento Indirizzo per abilitare Indirizzo di fatturazione. La fatturazione utilizza i propri campi dell'indirizzo.",
      "billingSameAsShipping": "L'indirizzo di fatturazione è lo stesso dell'indirizzo di spedizione",
      "phoneNumber": "Numero di telefono",
      "billingAddressEnableFailed": "Non siamo riusciti ad abilitare i campi dell'Indirizzo di fatturazione. Riprova a salvare."
    },
    "addressSettings": {
      "autoComplete": "Indirizzo a completamento automatico",
      "addressfields": "Campi indirizzo",
      "placeholderSearch": "Cerca un indirizzo",
      "autoCompleteTooltip": "Fornisce la possibilità di cercare e popolare automaticamente l'indirizzo.",
      "streetAddress": "Indirizzo",
      "autoCompleteAddressTitle": "Automatico Termina Indirizzo",
      "newBadge": "Nuovo",
      "defaultLabel": "Indirizzo",
      "searchPlaceholder": "Cerca Indirizzo",
      "mandataorySearch": {
        "title": "Obbligatorio a selezionare Indirizzo in Cerca Bar",
        "primaryText": "Completamento automatico solo per Indirizzo",
        "secondaryText": "Quando Abilitato, quando un utente interagisce con l'Indirizzo Campo, Poi deve selezionare un Indirizzo valido per Procedi.",
        "secondaryText1": "Quando Disabilitato Poi possono Procedi senza selezionare un Indirizzo in barra Cerca."
      }
    },
    "autoResponder": "Risponditore automatico",
    "workflow": "Flusso di lavoro",
    "workflowSubheader": "Automatizza ciò che accade dopo l'invio di un modulo",
    "workflowTitle": "Crea un flusso di lavoro semplice.",
    "workflowDescription": "Usa i flussi di lavoro per gestire i follow-up dopo che i contatti interagiscono con il tuo modulo. Ad esempio, puoi inviare loro un'email o un SMS di follow-up",
    "createWorkflow": "Crea un flusso di lavoro",
    "workflowVisualAlt": "Visualizzazione del flusso di lavoro",
    "autoResponderSubheader": "Invia un'email automatica alla persona che invia il modulo (l'email include una copia delle informazioni inserite nel modulo)",
    "replyToEmail": "Rispondi all'email",
    "open": "Aperta",
    "won": "Vinta",
    "lost": "Persa",
    "abandon": "Abbandona",
    "selectAPipeline": "Seleziona una sequenza",
    "stage": "Fase",
    "status": "Stato",
    "opportunityValue": "Valore dell'opportunità",
    "createNewPipeline": "Crea una nuova sequenza",
    "editOpportunitySettings": "Modifica le impostazioni delle opportunità",
    "contact": "Contatto",
    "opportunity": "Opportunità",
    "business": "Impresa",
    "add": "Aggiungi",
    "manage": "Gestisci",
    "more": "Più",
    "opportunityHeading": "Dove vuoi che la tua opportunità venga aggiornata?",
    "date": {
      "dateSettings": "Impostazioni data",
      "dateFormat": "Formato data",
      "dateSeparator": "Separatore di data",
      "dateFormatTooltipMessage": "Seleziona un formato di data. D sta per giorno, M per mese e Y per anno",
      "dateSeparatorTooltipMessage": "Seleziona un separatore che separerà giorno, mese e anno nel formato selezionato in Formato data",
      "disablePicker": "Disabilita selettore"
    },
    "dateTime": {
      "tabGeneral": "Generale",
      "tabFieldSettings": "Impostazioni del campo",
      "collectHeading": "Seleziona cosa dovrebbe raccogliere questo campo",
      "collectDate": "Data",
      "collectTime": "Ora",
      "collectDateTime": "Data e ora",
      "collectTypeLockedTooltip": "Il tipo di raccolta può essere modificato solo prima che il campo venga salvato.",
      "placeholderTextPlaceholder": "Aggiungi testo segnaposto",
      "shortLabelPlaceholder": "Aggiungi etichetta breve",
      "fieldSettingsBanner": "Definisca l'intervallo di date o orari consentito, limiti i giorni che gli utenti possono selezionare e scelga come visualizzare il valore.",
      "allowedDateRange": "Intervallo di date consentito",
      "dateModeAny": "Qualsiasi data",
      "dateModeFuture": "Solo date future",
      "dateModePast": "Solo date passate",
      "dateModeRange": "Intervallo di date specifico",
      "futureQuestion": "Quali date possono scegliere gli utenti?",
      "futureAny": "Qualsiasi data futura",
      "futureAnyDesc": "Gli utenti possono scegliere qualsiasi data successiva alla data attuale. Ad esempio: Prenota un incontro in qualsiasi momento del prossimo anno.",
      "futureBuffer": "Dopo il tempo di buffer",
      "futureBufferDesc": "Gli utenti possono selezionare date solo dopo un numero prestabilito di giorni. Ad esempio: Consenti prenotazioni a partire da 3 giorni da oggi.",
      "futureBufferSuffix": "giorni da oggi",
      "futureRolling": "Entro un determinato intervallo di date",
      "futureRollingDesc": "Gli utenti possono selezionare date entro un intervallo futuro specificato. Ad esempio: Consenti prenotazioni nei prossimi 30 giorni.",
      "futureRollingPrefix": "Avanti",
      "futureRollingSuffix": "giorni",
      "rangeLabel": "Intervallo di date specifico",
      "rangeStart": "Data di inizio",
      "rangeEnd": "Data di fine",
      "availableDays": "Giorni disponibili",
      "allowedTimeRange": "Intervallo di tempo consentito",
      "timeModeAny": "In qualsiasi momento",
      "timeModeRange": "Intervallo di tempo specifico",
      "timeRangeLabel": "Intervallo di tempo specifico",
      "timeStart": "Orario di inizio",
      "timeEnd": "Ora di fine",
      "timeFormatLabel": "Formato dell'ora",
      "timeFormat24": "24 ore",
      "timeFormat12": "AM / PM",
      "timePlaceholder": "HH:MM",
      "defaultTimeLabel": "Tempo predefinito",
      "defaultTimeHelper": "Precompilare con un'ora attuale o personalizzata.",
      "defaultTimeNone": "Nessuno",
      "defaultTimeCurrent": "Attuale",
      "defaultTimeCustom": "Personalizzata",
      "customTimeLabel": "Orario personalizzato",
      "customTimeError": "Inserisca un orario valido nel formato HH:MM.",
      "disableCalendarPopup": "Disabilita il popup del calendario",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Seleziona almeno un giorno disponibile",
      "dateRangeError": "La data di fine deve essere successiva o uguale alla data di inizio",
      "timeRangeError": "L'ora di fine deve essere successiva all'ora di inizio",
      "saveBlockedTitle": "Il campo data & ora è incompleto",
      "saveBlockedDescription": "Correggi gli errori di convalida di data e ora evidenziati prima di salvare.",
      "weekday": {
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mer",
        "thu": "Gio",
        "fri": "Ven",
        "sat": "Sab",
        "sun": "Dom"
      }
    },
    "restoreVersion": "Ripristina versione",
    "versionHistory": "Cronologia delle versioni",
    "versionPreviewTitle": "Anteprima della versione",
    "errorMessage": "Errore, riprova di nuovo",
    "version": "Versione:",
    "currentVersion": "Versione attuale",
    "messageStyling": "Stile dei messaggi",
    "validateEmailHeader": "Convalida email",
    "validateEmailDescription": "Il pulsante diventerà visibile una volta che l'utente avrà inserito la propria email. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "verifyEmail": "Verifica email",
    "validatePhoneHeader": "Convalida telefono",
    "validatePhoneDescription": "Il pulsante diventerà visibile una volta che l'utente avrà inserito il proprio numero di telefono. Questa funzione è progettata per aiutarti a generare lead di qualità.",
    "verifyPhone": "Verifica telefono",
    "validatePhoneWarning": "Per abilitare la verifica OTP via SMS, assicurati che il tuo numero di telefono sia configurato nelle tue impostazioni di luogo",
    "addAnotherTnc": "Aggiungi altri termini e condizioni",
    "tnc1": "Termini e condizioni 1",
    "tnc2": "Termini e condizioni 2",
    "deleteCaps": "DELETE",
    "deleteConfirmation": "Digita DELETE per confermare",
    "marginPadding": "Margine e spaziatura interna",
    "style": {
      "formLayoutType": "Tipo di modulo",
      "layoutType": "Tipo di Layout",
      "surveyType": "Tipo di Sondaggio",
      "oneColumn": "Una colonna",
      "twoColumn": "Due colonne",
      "singleLine": "Linea singola",
      "fieldWidth": "Larghezza del campo",
      "labelAlignment": {
        "labelAlignment": "Allineamento etichetta",
        "labelWidth": "Larghezza etichetta"
      },
      "fieldSpacing": "Spaziatura dei campi",
      "imageFieldSpacing": "Spaziatura di campi e immagini",
      "imageCornerRadius": "Raggio d'angolo dell'immagine",
      "color": "colore",
      "fontColor": "Colore del carattere",
      "inputBackgroundColor": "Colore di sfondo di input",
      "inputBorder": "Bordo di input",
      "layout": "Layout",
      "colorsAndBackground": "Colori e sfondo",
      "imageLayout": {
        "imageLayout": "Immagine Allineamento dei contenuti",
        "showImage": "Mostra immagine",
        "image": "Immagine",
        "desktop": {
          "topFixed": "Migliore Fisso",
          "leftCenter": "Centro sinistra",
          "rightCenter": "Centro a destra",
          "leftFixed": "Fisso a Sinistra",
          "rightFixed": "Fisso a destra",
          "background": "Sfondo"
        },
        "mobile": {
          "header": "Intestazione",
          "background": "Sfondo"
        }
      },
      "focusPoint": {
        "title": "Punto focale",
        "reset": "Reimposta",
        "noImage": "Nessuna immagine caricata"
      },
      "advanceSettings": "Impostazioni avanzate",
      "inputField": "Campo di inserimento",
      "borderWidth": "Larghezza del bordo",
      "borderColor": "Colore del bordo",
      "borderStyle": "Stile del bordo",
      "fontSize": "Dimensione del carattere",
      "fontWeight": "Peso del carattere",
      "labelColor": "Colore etichetta",
      "placeholderColor": "Colore segnaposto",
      "shortLabelColor": "Colore dell'etichetta breve"
    },
    "replyToTooltip": "Indica l'indirizzo email a cui devono essere inviate le risposte a questa notifica. Usa {'{'}{'{'}contact.email{'}'}{'}'} per permettere ai destinatari di rispondere direttamente alla persona che ha compilato il modulo.",
    "content": "Contenuti",
    "calculations": "Calcoli",
    "uploadOptions": "Opzioni di caricamento",
    "opportunitySettingsWarning": "Per configurare le impostazioni dell'opportunità, fai clic sul pulsante Modifica impostazioni opportunità.",
    "startValue": "Valore di Inizio",
    "endValue": "Valore finale",
    "today": "Oggi",
    "thisWeek": "Questa settimana",
    "last7Days": "Ultimi 7 giorni",
    "thisMonth": "Questo mese",
    "last30Days": "Ultimi 30 giorni",
    "question": "Domanda",
    "createContactOnPartialSubmission": "Crea contatto con invio parziale",
    "howItWorks": "Come funziona?",
    "createContactOnPartialSubmissionDescription": "Termina la diapositiva e fai clic su \"Successivo\". Un nuovo contatto verrà creato e memorizzato automaticamente.",
    "swapWarningMessageSurvey": "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. Può anche resettare la logica condizionale. ",
    "swapWarningMessageForm": "La modifica o lo scambio delle opzioni influirà su questo campo personalizzato in tutti i luoghi in cui viene utilizzato il campo. ",
    "migrationWarningMessage": "Questa funzionalità è stata migrata alla logica condizionale del sondaggio.",
    "optionLabel": "Etichetta opzione",
    "calculationValue": "Valore di calcolo",
    "addOption": "Aggiungi opzione",
    "addOtherOption": "Aggiungi opzione \"Altro\"",
    "otherOptionLabel": "Altro",
    "otherOptionPlaceholder": "Per favore, digiti un'altra opzione qui",
    "enableCalculations": "Abilita calcoli",
    "allowOtherOption": "Consenti altra opzione",
    "productSelectionSubtext": "Abilitazione individuale o selezione di Prodotti multipli",
    "multi": "Multi",
    "single": "Individuo",
    "productSelectionHeading": "Selezione Prodotto",
    "spreadToColumns": "Distribuisci su colonne",
    "columns": "Colonne",
    "customstyle": "Stile",
    "standard": "Standard",
    "bubble": "Bubble",
    "radioStyles": {
      "standardAlt": "Stile radio standard",
      "bubbleAlt": "Stile radio Bubble"
    },
    "integratePopup": {
      "title": "Integra modulo",
      "embedCode": "Codice di incorporamento",
      "useInFunnelOrEmbedCode": "Usa in funnel/codice di incorporamento",
      "iframeEmbed": "Incorpora Iframe",
      "layout": {
        "title": "Tipo di layout incorporato",
        "description": "Seleziona un layout da incorporare in un funnel o in un sito web esterno",
        "allowMinimize": "Consenti riduzione a icona",
        "minimizedTitlePlaceholder": "Titolo ridotto",
        "leftAlignAlt": "Allinea a sinistra",
        "rightAlignAlt": "Allinea a destra"
      },
      "triggerType": "Tipo di trigger",
      "triggers": {
        "seconds": "secondi"
      },
      "activation": {
        "title": "Opzioni di attivazione",
        "visit": "visita"
      },
      "deactivation": {
        "title": "Opzioni di disattivazione",
        "times": "volte"
      },
      "copyEmbedCode": "Copia codice di incorporamento",
      "copyFormLink": "Copia link del modulo",
      "openFormLink": "Apri il link del modulo",
      "invalidInput": "Input non valido!",
      "funnel": {
        "funnel": "Funnel",
        "chooseStep": "Seleziona a Passaggio",
        "copyCodeAndOpenFunnel": "Copia Codice e Apri Funnel"
      },
      "share": {
        "share": "Condividi",
        "shareViaSocials": "Condividi tramite Social",
        "copyLink": "Copia link"
      },
      "email": {
        "email": "Email",
        "shareViaEmail": "Condividi tramite Email",
        "emailButton": "Email",
        "blankTemplate": "Modello vuoto",
        "emailMarketingTemplates": "Modelli Email Marketing",
        "or": "O",
        "chooseTemplate": "Scegli dai tuoi modelli",
        "continue": "Continua"
      }
    },
    "rating": {
      "icon": "Icona",
      "iconAlignment": "Allineamento Icona",
      "count": "Numero",
      "lowestRating": "Valutazione minima",
      "highestRating": "Valutazione Massimo",
      "iconSelectedState": "Stato Icona Selezionato",
      "iconUnselectedState": "Stato Icona non selezionato",
      "rating": "Valutazione",
      "ratingSettings": "Impostazioni Valutazione",
      "calculationType": {
        "calculationType": "Come Archivia Valutazione Campi in Personalizzato Campi",
        "calculationTypeTooltip": "Quando Tu Frequenza qualcosa di 4 Da 5 stelle, significa: - Assoluto: 4 Da 5 - Percentuale: 80 - Frazione: 0.8",
        "absolute": "Assoluto",
        "percentage": "Percentuale",
        "fraction": "Frazione"
      }
    },
    "desktopMode": "Modalità desktop",
    "mobileMode": "Modalità mobile",
    "versions": "Varianti",
    "advanced": "Avanzato",
    "edit": "Modifica",
    "settings": "Impostazioni",
    "submissions": "Invii",
    "analytics": "Analitica",
    "notifications": "Notifiche",
    "undo": "Annulla",
    "redo": "Ripeti",
    "customValues": "Valori personalizzati",
    "pickBgFromImage": "Aggiunge una sfocatura sullo sfondo della tua casella dei messaggi. Se scegli un colore di sfondo per la casella dei messaggi, appare sopra la casella sfocata.",
    "pickBgFromImageTip": "Consente di selezionare un Colore con Confronta elevato per l'Immagine BG. Messaggio: non verrà applicata se lo Sfondo del Modulo non ha un'Immagine",
    "messageBackgroundBlur": "Sfocatura dello sfondo",
    "confirmationMessage": "Messaggio di conferma",
    "deleteOption": "Elimina opzione",
    "deleteConfirmationModal": {
      "defaultDescription": "L'eliminazione di un'opzione influirà su questa Personalizzato Campo su ogni Posti in cui viene utilizzato Campo. Sei sicuro che tu desideri eliminarlo?",
      "validationMessage": "Inserisci Elimina in Salva.",
      "validationError": "Inserisci Elimina"
    },
    "disqualifyImmediately": "Squalifica immediatamente",
    "disqualifyAfterSubmit": "Squalifica dopo l'invio",
    "generalSettings": "Impostazioni Generale",
    "advancedSettings": "Impostazioni avanzate",
    "customFieldName": "Personalizzato Settore Nome",
    "customFieldNameTooltip": "Questo Settore Nome è unico per Personalizzato Settore.",
    "customFieldNameTooltipContact": "Questi campi consentono agli utenti di raccogliere dettagli aggiuntivi su una persona, come il tipo di lead, la data di nascita o il metodo di contatto preferito.",
    "customFieldNameTooltipContactLearnMore": "Scopri di più",
    "customFieldNameTooltipOpportunity": "Questi campi vengono utilizzati per monitorare dati specifici dell'affare per ogni opportunità, inclusi dettagli come il budget o un obiettivo di chiusura.",
    "customFieldNameTooltipOpportunityLearnMore": "Scopri di più",
    "customFieldNameTooltipCompany": "Questi campi consentono la raccolta delle informazioni a livello organizzativo (ad esempio, per fornitori, clienti o agenzie) collegate ai contatti.",
    "customFieldNameTooltipCompanyLearnMore": "Scopri di più",
    "customFieldNameTooltipCustomObject": "Questi campi consentono agli utenti di raccogliere dati specifici per le aziende, come le informazioni su risorse, veicoli o proprietà, e di integrare tali dati nel loro sistema CRM.",
    "customFieldNameTooltipCustomObjectLearnMore": "Scopri di più",
    "uniqueKey": "Chiave univoca",
    "uniqueKeyTooltip": "Questa chiave è l'identificatore di sistema per il campo personalizzato. Una volta impostata, non può essere modificata.",
    "uniqueKeyTooltipLearnMore": "Scopri di più",
    "selectContactAssociation": "Seleziona la relazione con i Contatti",
    "selectObjectAssociation": "Seleziona l'associazione tra {objectA} e {objectB}",
    "pickHowRecordsLink": "Entrambi gli oggetti si trovano in questo modulo, quindi l'invio deve sapere come sono correlati.",
    "association": "Associazione",
    "newAssociationBetween": "Nuova associazione tra {objectA} e {objectB}",
    "opportunitySetupTitle": "Configura questa opportunità",
    "opportunitySetupSubtitle": "Scegli dove atterra.",
    "opportunitySetupSubtitleLinked": "Seleziona dove atterra e come si collega a {object}.",
    "opportunityPlacement": "Posizionamento dell'opportunità",
    "newPipeline": "Nuova sequenza",
    "associations": "Associazioni",
    "createNewAssociation": "Crea nuova associazione",
    "selectAnAssociation": "Seleziona un'associazione",
    "loadingAssociations": "Caricamento delle associazioni...",
    "unknownAssociation": "Relazione Sconosciuta",
    "manyToMany": "Molti a molti",
    "failedToLoadAssociations": "Caricamento delle associazioni non riuscito",
    "noAssociationsFound": "Nessuna associazione trovata",
    "keepThisField": "Mantieni questo campo",
    "customObject": "Oggetto personalizzato",
    "customObjects": "Oggetti personalizzati",
    "object": "Oggetto",
    "editAssociation": "Modifica associazione {objectName}",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Campi",
    "primaryFieldWarning": "{fieldName} è un campo PRIMARIO per {objectSingular} ed è Obbligatorio per creare o aggiornare un {objectSingular}.",
    "primaryFieldTitle": "{fieldName} è Obbligatorio per creare o Aggiornare il Documento {objectSingular}.",
    "removeAllFields": "Rimuovi tutti i campi {objectSingular}",
    "customObjectsFallback": "Oggetti personalizzati",
    "noneAssociation": "Nessuno",
    "noneAssociationDescription": "Nessuna relazione con i Contatti (nessun Campo Contatto presente)",
    "survey": {
      "layoutType": "Tipo di sondaggio",
      "oneQuestionPerPage": "Una domanda alla volta",
      "allQuestionsOnePage": "Molte alla volta"
    },
    "quizQuestions": "Interrogatorio del quiz",
    "choiceElements": "Scelta componenti",
    "otherElements": "Altro Componenti",
    "listEditor": {
      "prefillValueHeader": "Valore Precompila",
      "labelPlaceholder": "Etichetta",
      "valuePlaceholder": "Valore",
      "optionRequiredError": "L'opzione Campo è Obbligatorio"
    },
    "field": "Campo",
    "scoreEditor": {
      "addFieldPlaceholder": "Aggiungi Campo",
      "fieldLabel": "Campo",
      "numberLabel": "numero"
    },
    "fileUploadEditor": {
      "fileTypes": "Tipi di file",
      "all": "ogni",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV",
      "fileAccess": "Accesso ai file",
      "fileAccessDescription": "Scegli chi può accedere ai file caricati in questo campo. Questa impostazione non può essere modificata dopo che il campo è stato creato.",
      "fileAccessLocked": "Una volta creato il campo, la sua impostazione di accesso ai file non può essere modificata.",
      "privateFiles": "File privati",
      "privateFilesTooltip": "Solo gli utenti autorizzati possono visualizzare e scaricare i file.",
      "publicFiles": "File pubblici",
      "publicFilesTooltip": "Chiunque abbia il link al file può visualizzare e scaricare i file."
    },
    "ok": "Ok",
    "allowMultipleFiles": "Consenti più file",
    "maxFileLimit": "Limite massimo di file",
    "privacyPolicy": "Informativa sulla privacy",
    "termsOfService": "Termini di servizio",
    "colorPicker": {
      "brandColors": "Colori del brand",
      "defaultColors": "Colori predefiniti",
      "globalCustomColors": "Colori personalizzati globali"
    },
    "billingFrequency": "Frequenza di Fatturazione",
    "otherAmount": "Altro importo",
    "exampleUrlPlaceholder": "https://www.esempio.com",
    "checkboxStyles": {
      "standardAlt": "Stile casella di controllo standard",
      "bubbleAlt": "Stile casella di controllo bubble"
    },
    "previewIcons": {
      "exportAlt": "Icona di esportazione",
      "shipmentAlt": "Icona di spedizione",
      "resultAlt": "Icona della pagina dei risultati"
    },
    "examples": {
      "sampleUrl": "https://esempio.com"
    },
    "showing": "Presentazione",
    "of": "di",
    "enterCouponCode": "Inserisci codice coupon",
    "apply": "Applica",
    "paymentWillBeProcessed": "Il pagamento verrà elaborato non appena procederai al passaggio successivo",
    "paymentWillBeProcessedNextSlide": "Il pagamento verrà elaborato non appena l'utente procederà alla diapositiva successiva",
    "showThisAlertToUsers": "Mostra questo avviso agli utenti",
    "sixteenDigitCardNumber": "Numero di carta a 16 cifre",
    "mmYy": "MM / AA",
    "cvc": "CVC",
    "threeDigitCode": "codice a 3 cifre",
    "enterCardNumber": "Inserisci il numero della carta",
    "pleaseFillRequiredFields": "Compila tutti i campi obbligatori!",
    "opportunitySettingsIncomplete": "Impostazioni delle opportunità incomplete",
    "opportunitySettingsIncompleteDescription": "Questo modulo include i campi Opportunità, ma le impostazioni delle opportunità non sono state aggiornate. Configura le impostazioni delle opportunità per procedere con il salvataggio del modulo.",
    "ariaAttributes": {
      "iconSearch": "Ricerca icona"
    },
    "alt": {
      "standardRadioStyle": "Stile radio standard",
      "bubbleRadioStyle": "Stile radio bubble"
    },
    "value": "Valore",
    "jumpTo": "Salta a",
    "thankYouJohnDoe": "Grazie, signor John Doe",
    "total": "Totale",
    "urlExamples": {
      "simple": "esempio.com",
      "https": "https://esempio.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Grazie per aver dedicato del tempo a completare questo quiz."
  },
  "overallScore": {
    "defaultTitle": "Punteggio complessivo"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Scelta individuale",
      "multipleChoice": "Scelta multipla",
      "yesNo": "Sì / No",
      "shortAnswer": "Video breve Risposto",
      "longAnswer": "Risposto lungo",
      "number": "numero",
      "singleDropdown": "Elenco a discesa individuale",
      "multiDropdown": "Elenco a Elenco a discesa multiplo"
    },
    "personal": {
      "fullName": "Nome Pieno",
      "firstName": "Nome",
      "lastName": "Cognome",
      "dateOfBirth": "Data di nascita",
      "phone": "Telefono",
      "email": "Gmail",
      "fullNamePlaceholder": "Inserisci il tuo nome e cognome",
      "firstNamePlaceholder": "Inserisci il tuo nome",
      "lastNamePlaceholder": "Inserisci il tuo cognome",
      "dateOfBirthPlaceholder": "GG / MM / AAAA",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Pulsante"
    },
    "integration": {
      "sellProducts": "Vendi prodotti",
      "collectPayment": "Raccogli Pagamento"
    },
    "address": {
      "address": "Indirizzo",
      "streetAddress": "Indirizzo",
      "city": "Città",
      "state": "Stato",
      "country": "Paese",
      "postalCode": "Codice postale",
      "organization": "Gruppo",
      "website": "Sito web",
      "websitePlaceholder": "https://iltuositoweb.com",
      "addressPlaceholder": "Indirizzo",
      "streetAddressPlaceholder": "Inserisci il tuo indirizzo completo",
      "cityPlaceholder": "Inserisci la tua città",
      "statePlaceholder": "Inserisci il tuo stato",
      "countryPlaceholder": "Inserisca il suo paese",
      "postalCodePlaceholder": "CAP o codice postale",
      "organizationPlaceholder": "Inserisca la Sua organizzazione"
    },
    "text": {
      "singleLine": "Linea individuale",
      "multiLine": "Linea",
      "textBoxList": "Testo Quadrato",
      "singleLinePlaceholder": "Inserisca il testo",
      "multiLinePlaceholder": "Digita qui il tuo messaggio"
    },
    "choiceElements": {
      "singleDropdown": "Elenco a discesa individuale",
      "multiDropdown": "Elenco a Elenco a discesa multiplo",
      "checkbox": "Casella di controllo",
      "radio": "Radio button",
      "singleDropdownPlaceholder": "Seleziona un'opzione",
      "multiDropdownPlaceholder": "Scegli una o più opzioni",
      "pictureChoice": {
        "label": "Scelta immagine",
        "multipleSelection": "Selezione multipla",
        "selectionTypeLocked": "Il tipo di selezione non può essere modificato dopo che questo campo personalizzato è stato salvato.",
        "imageRequiredBeforeSave": "Ogni opzione in un elemento Picture Choice deve avere un'immagine.",
        "labelRequiredBeforeSave": "Ogni opzione in un elemento Picture Choice deve avere un'etichetta.",
        "duplicateOptionLabelsBeforeSave": "Ogni opzione in un elemento Picture Choice deve avere un'etichetta unica.",
        "selectionLimitInvalidBeforeSave": "Inserisca un limite di selezione valido per l'elemento Scelta Immagine.",
        "selectionLimit": "Limite di selezione",
        "unlimited": "Unlimited",
        "exact": "Exact",
        "range": "Intervallo",
        "exactSelections": "Selezioni precise",
        "minimum": "Minimo",
        "maximum": "Massimo",
        "options": "Opzioni",
        "optionSettings": "Impostazioni opzioni",
        "showOptionLabel": "Mostra etichetta opzione",
        "addOption": "Aggiungi opzione",
        "otherOption": "Altra opzione",
        "imageFit": "Adattamento dell'immagine",
        "cover": "Copertina",
        "contain": "Contiene",
        "fill": "Riempi",
        "spreadToColumns": "Distribuisci su colonne",
        "columns": "Colonne",
        "numberOfColumns": "Numero di colonne",
        "desktopColumnsLimit": "{count} colonne massime su desktop.",
        "mobileColumnsLimit": "Massimo {count} colonne su dispositivi mobili.",
        "otherOptionLabel": "Etichetta opzione alternativa",
        "optionLabel": "Etichetta opzione",
        "image": "Immagine",
        "media": "Contenuti multimediali",
        "otherImageUploadUnavailable": "Non è possibile caricare un'immagine per l'opzione Altro.",
        "removeImage": "Rimuovi immagine",
        "deleteOption": "Elimina opzione",
        "altText": "Testo alternativo"
      }
    },
    "customized": {
      "text": "Testo",
      "html": "Html",
      "htmlPlaceholder": "L'HTML Personalizzato va qui",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Problema",
      "botProtection": "Protezione dai bot",
      "verificationMode": "Modalità di Verifica",
      "interactive": "Interattivo",
      "invisible": "Invisibile",
      "invisibleModeDescription": "Questa verifica viene eseguita automaticamente in background e non sarà visibile agli utenti",
      "fieldHiddenWarning": "Questo campo è nascosto e non sarà visibile nel modulo.",
      "verifyHuman": "Verifica di essere un umano",
      "privacy": "Privacy",
      "help": "Aiuto",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Fonte",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "Accetto i termini e le condizioni Emesso tramite l'impresa. Tramite fornendo il mio Numero di telefono, accetto che Eredita Testo invii messaggi Da the business.",
      "score": "Punteggio",
      "scorePlaceholder": "Es: Il Suo punteggio è 100%"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Inserisci un URL",
      "image": "Immagine",
      "fileUpload": "Carica File",
      "monetary": "Monetario",
      "number": "numero",
      "datePicker": "Data e ora",
      "datePickerLegacy": "Selettore di data",
      "datePickerGeneratedName": "Data",
      "timePickerGeneratedName": "Ora",
      "dateTimePickerGeneratedName": "Data e ora",
      "signature": "Firma",
      "monetaryPlaceholder": "Inserisci importo",
      "signaturePlaceholder": "Firmi qui",
      "numberPlaceholder": "Inserisci un numero",
      "datePickerPlaceholder": "GG / MM / AAAA",
      "imageUploadPlaceholder": "Non è stata ancora aggiunta nessuna immagine",
      "imageUploadSubText": "Carica su Archivio dei contenuti multimediali o trascina e rilascia",
      "imageUploadButtonText": "Carica immagine",
      "fileText": "File",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Fai clic per caricare"
    },
    "customstyle": "Stile",
    "standard": "Standard",
    "bubble": "Bubble"
  },
  "survey": {
    "addSlideText": "Aggiungi elementi",
    "defaultScreenTitle": "Trascina e rilascia i componenti",
    "defaultScreenDescription": "Sposta la tua domanda alla pagina {pageIndex} utilizzando gli elementi a sinistra.",
    "typeOfBuilder": "Sondaggio",
    "survyeStyle": "Stile del sondaggio",
    "surveyName": "Nome del sondaggio",
    "surveyElement": "Elemento del sondaggio",
    "addSurveyElement": "Aggiungi elemento del sondaggio",
    "cloneSlide": "Clone Scorri",
    "unsavedAlertMessage": "Il sondaggio contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage": "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel sondaggio.",
    "integrateHeader": "Integra sondaggio",
    "integrateSubHeader": "Usa le seguenti opzioni per integrare il tuo sondaggio personalizzato nel tuo sito web",
    "integrateCopyLinkMessage": "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "onSurveySubmission": "All'invio del sondaggio",
    "saveExitConfirmation": "Salva i progressi dei sondaggi",
    "surveySettings": "Impostazioni sondaggio",
    "oneQuestionAtTime": "Una domanda alla volta",
    "backButton": "Pulsante Indietro",
    "backButtonTooltipMessage": "Il pulsante Indietro aiuterà gli utenti a spostarsi alla diapositiva precedente",
    "disableAutoNavigation": "Disabilita navigazione automatica",
    "disableAutoNavigationTooltipMessage": "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "autoNavigation": "Navigazione Automatico",
    "autoNavigationTooltipMessage": "Passa automaticamente alla risposta di Successivo Scorri Dopo un utente.",
    "progressBar": "Barra di avanzamento",
    "progressBarTooltipMessage": "Disattivando questa opzione verrà rimossa la barra di avanzamento dal sondaggio",
    "disableAnimation": "Disabilita animazione",
    "disableAnimationTooltipMessage": "Attivando questa opzione verrà disabilitata l'animazione di transizione della diapositiva",
    "scrollToTop": "Scorri verso l'alto",
    "scrollToTopTooltipMessage": "Se l'opzione è attivata, il sondaggio scorrerà verso l'alto nella diapositiva successiva",
    "submitSurvey": "Invia sondaggio",
    "disqualifyImmediately": "Squalifica immediatamente",
    "disqualifyAfterSubmit": "Squalifica dopo l'invio",
    "disqualifyAfterSubmitLowerCase": "Squalifica dopo l'invio",
    "footerHTML": "Piè di pagina HTML",
    "footerHTMLMessage": "Puoi scrivere CSS personalizzati (usando l'etichetta di stile) e HTML all'interno della stessa casella",
    "editFooter": "Modifica piè di pagina",
    "disqualifySettings": "Impostazioni di squalifica",
    "disqualifyImmediatelyLabel": "Immediatamente",
    "disqualifyAfterSubmitLabel": "Dopo l'invio",
    "slideConflictAlertMessage": "Questa diapositiva contiene più domande con una logica impostata. Ciò può causare alcuni comportamenti indesiderati",
    "addSlide": "Aggiungi diapositiva",
    "settings": "Impostazioni",
    "delete": "Elimina",
    "slideDeleteAlertMessage": "Vuoi davvero eliminare questa diapositiva?",
    "slideDeleteBetweenAlertMessage": "Questo riorganizzerà le altre diapositive. Vuoi davvero eliminare questa diapositiva?",
    "slideLabel": "Diapositiva {n}",
    "slideName": "Nome diapositiva",
    "slidePosition": "Posizione della diapositiva",
    "jumpTo": "Salta a",
    "jumpToSubText": "Vai a una diapositiva specifica",
    "enableTimezoneSurvey": "L'attivazione di questa opzione acquisirà le informazioni sul fuso orario della persona che invia il sondaggio",
    "footer": {
      "footer": "Piè di pagina",
      "enableNewFooter": "Abilita nuovo piè di pagina",
      "stickToSurvey": " Fissa al sondaggio",
      "backgroundFill": "Riempimento sfondo",
      "footerHeight": "Altezza del piè di pagina",
      "enableProgressBar": "Abilita barra di avanzamento",
      "buttons": "Pulsanti",
      "button": "Pulsante",
      "buttonType": "Tipo di pulsante",
      "buttonTypeTooltip": "Scegli come vengono visualizzati i pulsanti di navigazione nel piè di pagina del sondaggio",
      "fillNext": "Riempi (successivo)",
      "fillPrevious": "Riempi (precedente)",
      "fillSubmit": "Compila (Invia)",
      "textColor": "Testo del pulsante",
      "position": "Posizione",
      "positionTooltip": "Scegli come vengono visualizzati i pulsanti di navigazione nel piè di pagina del sondaggio",
      "previousText": "Precedente (testo)",
      "nextText": "Successivo (testo)",
      "submitText": "Invia (testo)",
      "fillComplete": "Riempimento completo",
      "fillInactive": "Riempimento inattivo",
      "footerType": "Tipo di piè di pagina",
      "stickToCard": "Fissa alla scheda",
      "stickToPage": "Fissa alla pagina",
      "stepTextColor": "Passaggio Corpo Color",
      "progressBarFill": "Riempi la Barra di avanzamento",
      "progressBarInactive": "Barra di avanzamento Inattivo",
      "arrowFill": "Riempi a Freccia",
      "submitColorMobile": "Invia (Colore)",
      "arrowFillColor": "Colore Riempi Freccia",
      "buttonTypes": {
        "textAndArrow": "Testo e freccia",
        "onlyText": "Solo Testo",
        "onlyArrow": "Solo freccia"
      },
      "positions": {
        "leftAndRight": "Sinistra e destra"
      },
      "placeholders": {
        "prev": "Precedente",
        "next": "Successivo",
        "submit": "Invia"
      }
    },
    "surveyNotfication": "Notifica del sondaggio",
    "style": {
      "surveyPadding": "Spaziatura del sondaggio"
    },
    "integratePopup": {
      "shareOrEmbed": "Incorpora o Condividi Sondaggio",
      "share": {
        "openFormLink": "Apri il Link Sondaggio"
      },
      "email": {
        "emailSubheader": "Crea Email vuota e incorpora il tuo Sondaggio, o Seleziona a Modello e incorporalo immediatamente."
      }
    },
    "autoResponderSubheader": "Invia un'email automatica alla persona che invia il sondaggio (l'email include una copia delle informazioni inserite nel sondaggio)",
    "sendSubmissionsAsPdf": "Invia l'invio del sondaggio come PDF",
    "switchToOneQuestionAtTimeOn": "L'attivazione di \"Una domanda per dati\" interrompe la logica condizionale attuale",
    "switchToOneQuestionAtTimeOff": "La disabilità \"Una domanda a un dato\" influisce sulla tua logica condizionale",
    "switchToOneQuestionAtTimeOnWarning": "Alcune condizioni non funzioneranno più come previsto. Le domande Quando sono Presentazione one at a Data.",
    "switchToOneQuestionAtTimeOffWarning": " Alcune condizioni progettate per Flusso della domanda individuale smetteranno di funzionare come previsto.",
    "createContactOnPartialSubmissionSubText": "Crea un contatto quando un utente fa clic su \"Avanti\" su qualsiasi diapositiva, anche se non completa il sondaggio.",
    "dragDrop": {
      "imageLabel": "Immagine {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Sondaggio {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Informativa sulla Privacy</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Termini di Servizio</a></p>",
      "smsConsent": "Acconsento a ricevere notifiche SMS, avvisi e occasionali comunicazioni di marketing dall'azienda. La frequenza dei messaggi varia. Potrebbero essere applicate tariffe per messaggi e dati. Invia HELP a (XXX) XXX-XXXX per ricevere assistenza. Puoi rispondere STOP per annullare l'iscrizione in qualsiasi momento."
    }
  },
  "form": {
    "typeOfBuilder": "Modulo",
    "formStyle": "Stile del modulo",
    "formElement": "Elemento del modulo",
    "addFormElement": "Aggiungi elemento modulo",
    "addConditionalLogic": "Aggiungi logica condizionale",
    "openConditionalLogic": "Apri logica condizionale",
    "inlineForm": "Modulo in linea",
    "formName": "Nome del modulo",
    "fullScreenMode": "Modalità a schermo intero",
    "fullScreenModetooltip": "L'attivazione di questa opzione farà sì che il modulo si espanda su tutta la larghezza del contenitore, estendendosi fino al bordo dell'area di incorporamento e aderendo alla larghezza del modulo.",
    "enableTimezoneForm": "Attivando questa opzione si acquisiscono le informazioni sul fuso orario della persona che invia il modulo",
    "formSettings": "Impostazioni del modulo",
    "scheduleVisibility": {
      "title": "Programma la visibilità {product}",
      "subtitle": "Imposta quando questo {product} dovrebbe iniziare e smettere di accettare risposte. Al di fuori di questa finestra, i visitatori vedranno i messaggi configurati di seguito.",
      "formOpens": "{Product} apre",
      "formCloses": "{Product} chiude",
      "rightAway": "Immediatamente",
      "never": "Mai",
      "pickADate": "Seleziona una data",
      "opensPlaceholder": "Si apre non appena pubblichi",
      "closesPlaceholder": "Rimane aperto finché non lo chiudi",
      "date": "Data",
      "time": "Ora",
      "timezone": "Fuso orario",
      "timezoneHelp": "Si applica sia all'orario di apertura che a quello di chiusura.",
      "timezonePlaceholder": "Seleziona un fuso orario",
      "timeline": {
        "notOpenYet": "Non ancora aperto",
        "acceptingResponses": "Accettazione delle risposte",
        "closed": "Chiuso",
        "current": "Attuale",
        "opens": "Si apre",
        "closes": "Si chiude"
      },
      "whatVisitorsSee": "Cosa vedono i visitatori",
      "whatVisitorsSeeHelp": "Queste pagine vengono visualizzate solo al di fuori della finestra aperta. Seleziona uno stato per configurarlo.",
      "states": {
        "beforeTitle": "Prima che il {product} apra",
        "afterTitle": "Dopo la chiusura del {product}",
        "showsPage": "Mostra una pagina personalizzata",
        "redirectsTo": "Reindirizza a {url}"
      },
      "showPage": "Mostra una pagina",
      "showPageHelp": "Progetta ciò che vedranno i visitatori.",
      "openLink": "Apri un link",
      "openLinkHelp": "Inviali a un altro URL.",
      "redirectUrl": "URL di reindirizzamento",
      "redirectUrlPlaceholder": "https://example.com",
      "redirectUrlHelp": "I visitatori in questo stato vengono inviati qui invece di visualizzare una pagina. Usa un URL completo come https://example.com/path.",
      "redirectUrlInvalid": "Inserisca un URL valido che inizi con http:// o https://, ad esempio https://example.com/path.",
      "defaultBeforeMessage": "Questo {product} non è ancora aperto",
      "defaultAfterMessage": "Questo {product} è ora chiuso",
      "defaultBeforeBody": "Questo {product} non accetta ancora risposte. Ricontrolla quando sarà aperto per inviare la tua risposta.",
      "defaultAfterBody": "Grazie per il tuo interesse! Questo {product} ha smesso di accettare risposte. Contatta il proprietario di {product} se hai ancora bisogno di metterti in contatto.",
      "closeAfterOpenError": "L'orario di chiusura deve essere successivo all'orario di apertura.",
      "preview": {
        "label": "Anteprima",
        "labelHint": "— come lo vedono i visitatori",
        "redirectTo": "Ti reindirizzeremo a:",
        "poweredBy": "Offerto dalla tua agenzia"
      },
      "appearance": {
        "title": "Aspetto",
        "cardBackground": "Sfondo della scheda",
        "pageBackground": "Sfondo della pagina",
        "cornerRadius": "Raggio d'angolo",
        "cardWidth": "Larghezza scheda",
        "cardHeight": "Altezza scheda",
        "shadow": "Ombreggiatura",
        "autoPlaceholder": "Automatico",
        "marginPadding": "Margine e spaziatura interna",
        "auto": "automatico",
        "miscellaneous": "Varie",
        "agencyBranding": "Branding dell'agenzia",
        "agencyBrandingHelp": "Mostra il logo e il nome della tua agenzia nelle pagine dello stato chiuso.",
        "shadowOptions": {
          "none": "Nessuno",
          "soft": "Morbido",
          "elevated": "Elevato"
        },
        "colors": {
          "default": "Predefinito",
          "lightGray": "Grigio chiaro",
          "brandTint": "Tinta del marchio",
          "blush": "Rosa cipria",
          "dark": "Scuro",
          "white": "Bianco",
          "coolGray": "Grigio freddo"
        }
      }
    },
    "saveExitConfirmation": "Salva l'avanzamento dei moduli",
    "unsavedAlertMessage": "Il modulo contiene lavoro non salvato. Vuoi davvero uscire ed eliminare tutto il lavoro non salvato?",
    "thirdPartyScriptAlertMessage": "Gli script di terze parti all'interno del blocco HTML possono fornire potenti funzionalità, ma comportano anche rischi per la privacy, la sicurezza, le prestazioni e il comportamento della pagina. Pertanto, ti consigliamo di rivedere il contenuto di questo script prima di salvarlo nel modulo.",
    "onFormSubmission": "All'invio del modulo",
    "integrateForm": "Integra modulo",
    "embedlayoutType": "Incorpora Digita Layout",
    "embedlayoutTypeSubMessage": "Seleziona un layout da incorporare in un funnel o in un sito web esterno",
    "triggerType": "Tipo di trigger",
    "showOnScrolling": "Mostra su scorrimento",
    "showAfter": "Mostra dopo",
    "seconds": "secondi",
    "alwaysShow": "Mostra sempre",
    "activationOptions": "Opzioni di attivazione",
    "activateOn": "Attiva il",
    "visit": "visita",
    "alwaysActivated": "Sempre attivato",
    "deactivationOptions": "Opzioni di disattivazione",
    "deactivateAfterShowing": "Disattiva dopo la visualizzazione",
    "times": "volte",
    "deactiveOnceLeadCollected": "Disattiva una volta raccolto il lead",
    "neverDeactivate": "Non disattivare mai",
    "copyEmbedCode": "Copia codice di incorporamento",
    "copyFormLink": "Copia link del modulo",
    "openFormLink": "Apri il link del modulo",
    "inline": "In linea",
    "inlineDescription": "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "inlineHoverDescription": "Un modulo in linea viene visualizzato insieme al contenuto della pagina come elemento nativo. Non si sovrappone e non può essere chiuso o ridotto a icona.",
    "popup": "Popup",
    "popupDescription": "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "popupHoverDescription": "Un popup mostra il modulo come una sovrapposizione all'interno di una light-box. Non può essere ridotto a icona, ma può essere chiuso.",
    "politeSlideIn": "Pannello di cortesia",
    "politeSlideInDescription": "Un pannello di cortesia appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "politeSlideInHoverDescription": "Appare nella parte inferiore dello schermo e scompare una volta chiuso",
    "stickySidebar": "Barra laterale fissa",
    "stickySidebarDescription": "Una barra laterale fissa apparirà a lato dello schermo e può essere ridotta a icona in una scheda che resta fissa al lato della finestra",
    "stickySidebarHoverDescription": "Appaiono a lato dello schermo e possono essere ridotti a icona in una scheda che resta fissa al lato della finestra",
    "allowMinimize": "Consenti riduzione a icona",
    "checkForCookieConsent": "Rispetta il consenso ai cookie del sito ospitante",
    "checkForCookieConsentTooltip": "Gli eventi del pixel vengono attivati solo dopo che il visitatore ha accettato i cookie di marketing sul sito in cui questo modulo è incorporato. Il rilevamento automatico cerca GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi e IAB TCF.",
    "cookieConsentProvider": "Fornitore di consenso ai cookie",
    "cookieConsentProviderPlaceholder": "Seleziona il tuo banner di consenso ai cookie",
    "cookieConsentProviderAutoDetect": "Rilevamento automatico",
    "modalHeight": "Altezza modale",
    "modalHeightPlaceholder": "Inserisci l'altezza del modale",
    "conditonalLogic": {
      "conditions": "Condizioni",
      "noExistingCondition": "Ancora nessuna condizione esistente",
      "freeRoamMessage": "Puoi girare liberamente senza regole, almeno per ora",
      "addNewCondition": "Aggiungi nuova condizione",
      "redirectToUrl": "Reindirizza all'URL",
      "displayCustomMessage": "Visualizza messaggio personalizzato",
      "disqualifyLead": "Squalifica il lead",
      "showHideFields": "Mostra/Nascondi campi",
      "jumpTo": "Salta a",
      "redirectToUrlSubText": "Reindirizza l'utente dopo l'invio",
      "displayCustomMessageSubText": "Mostra messaggi basati sugli input di Attivo Utente",
      "disqualifyLeadSubText": "Filtra le voci in condizioni specifiche",
      "showHideFieldsSubText": "Modifica campo Visibilità in modo dinamico",
      "openBelowUrl": "Apri l'URL sottostante",
      "showCustomMessage": "Mostra messaggio personalizzato",
      "alertConditionDelete": "Vuoi davvero eliminare questa condizione?",
      "deleteCondition": "Elimina condizione",
      "conditionExecutedMessage": "Le condizioni verranno eseguite dall'alto verso il basso.",
      "anyVariant": "Qualsiasi variante",
      "bumpSuffix": "Offerta aggiuntiva",
      "untitledProduct": "Prodotto senza titolo",
      "deletedProduct": "Prodotto eliminato",
      "deletedVariant": "Variante eliminata",
      "allOperationOptions": {
        "isEqualTo": "È uguale a",
        "isNotEqualTo": "Non è uguale a",
        "contains": "Contiene",
        "doesNotContain": "Non contiene",
        "startsWith": "Inizia con",
        "endsWith": "Termina con",
        "isEmpty": "È vuoto",
        "isFilled": "È riempito",
        "before": "Prima",
        "after": "Dopo",
        "greaterThan": "Maggiore di",
        "lessThan": "Meno di",
        "between": "Tra",
        "isChecked": "È selezionato",
        "isNotChecked": "Non è selezionato",
        "isSelected": "È selezionato",
        "isNotSelected": "Non è selezionato",
        "pricingOptionIs": "L'opzione di prezzo è",
        "pricingOptionIsNot": "L'opzione di prezzo non è"
      },
      "logic": {
        "if": "Se",
        "then": "Allora",
        "and": "E",
        "or": "O"
      },
      "phoneAlertMessage": "Per cercare numeri di telefono con un prefisso internazionale, devi includere esplicitamente il simbolo \"+\" nella query di ricerca.",
      "deleteAlertMessage": "Vuoi davvero eliminare questo campo? Verrà rimossa anche la condizione associata a questo campo.",
      "deleteField": "Elimina campo",
      "jumpToDescription": "Salta a una diapositiva specifica quando le condizioni sono soddisfatte",
      "cycleError": "Impossibile Salva. Ciclo rilevato tra {a} e {b}",
      "jumpToSlide": "Salta alla diapositiva",
      "submitSurvey": "Salva sondaggio",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Fai clic su Scorri da cui saltare",
      "selectedSlide": "Diapositiva selezionata",
      "typeValueHere": "Per favore, digiti un valore qui",
      "field": "Campo",
      "slide": "Scorri",
      "selectFieldOrSlide": "Seleziona campo o diapositiva",
      "selectFieldState": "Seleziona Stato campo",
      "selectField": "Seleziona campo",
      "quizFields": "Campi del quiz",
      "standardFields": "Campi standard",
      "highestScore": "Punteggio più alto",
      "lowestScore": "Punteggio più basso",
      "overallScore": "Punteggio complessivo",
      "categoryScore": "Punteggio categoria",
      "selectCategory": "Seleziona categoria",
      "scoreFormat": "Formato punteggio",
      "percentage": "Percentuale",
      "actualScore": "Punteggio Effettivo",
      "outOf10": "Su 10",
      "selectOption": "Seleziona opzione",
      "jumpToTarget": "Salta a",
      "jumpToQuestion": "Vai alla Domanda",
      "chooseQuestion": "Scegli domanda",
      "includeStart": "Includi inizio",
      "includeEnd": "Includi la fine",
      "includeValue": "Includi {value}",
      "hideField": "Nascondi campo",
      "hideFields": "Nascondi campi",
      "showField": "Mostra campo",
      "showFields": "Mostra campi",
      "additionalRulesPrefix": "... e",
      "additionalRulesSuffix": "altre {ifLabel} regole ...",
      "shownTargetsWithMore": "{shown}, + altri {count}",
      "noConditionsAlt": "Ancora nessuna condizione",
      "outcomeLabels": {
        "show": "Mostra",
        "jumpTo": "Salta a"
      },
      "entireSection": "Intera sezione",
      "specificProducts": "Prodotti specifici",
      "mainProduct": "Prodotto principale",
      "bumpProduct": "Prodotto aggiuntivo",
      "searchProductsOrVariants": "Cerca prodotti o varianti",
      "selectAll": "Seleziona tutto",
      "clear": "Rimuovi",
      "variantsCount": "{count} varianti",
      "productsSelectedCount": "{selected} di {total} prodotti",
      "selectAtLeastOneProduct": "Seleziona almeno 1 prodotto o variante.",
      "productHint": {
        "entireHide": "L'intera sezione {section} è nascosta quando la condizione è soddisfatta.",
        "entireShow": "L'intera sezione {section} rimane nascosta finché la condizione non viene soddisfatta.",
        "specificHide": "Gli elementi selezionati vengono nascosti quando la condizione è soddisfatta.",
        "specificShow": "Elementi selezionati restano nascosti finché la condizione non viene soddisfatta.",
        "allSelectedHide": "Tutti i prodotti sono selezionati, quindi l'intera sezione sarà nascosta.",
        "allSelectedShow": "Ogni prodotto è selezionato, quindi l'intera sezione rimane nascosta finché la condizione non viene soddisfatta."
      },
      "productsCountShort": "{count} prodotti",
      "noProductsMatchSearch": "Nessun prodotto corrisponde a questa ricerca.",
      "noProductsTitle": "Nessun prodotto ancora in questo campo",
      "noProductsBody": "Aggiungi prodotti a {section} per mostrarli o nasconderli uno per uno. Puoi ancora nascondere l'intera sezione.",
      "remove": "Rimuovi",
      "deletedProductTitleOne": "1 prodotto non esiste più",
      "deletedProductTitleOther": "{count} prodotti non esistono più",
      "deletedProductBodyOne": "Un prodotto selezionato è stato rimosso da {section}. Rimuovilo da questa condizione per salvare.",
      "deletedProductBodyOther": "I prodotti selezionati sono stati rimossi da {section}. Rimuovili da questa condizione per salvare.",
      "selectPricingOption": "Seleziona un'opzione di prezzo",
      "selectProduct": "Seleziona prodotto"
    },
    "minimizedTitlePlaceholder": "Titolo ridotto",
    "dragYourElementFromLeft": "Trascina i tuoi elementi qui da sinistra",
    "formNotification": "Notifica modulo",
    "sendSubmissionsAsPdf": "Invia l'invio del modulo come PDF",
    "style": {
      "formPadding": "Spaziatura modulo"
    },
    "integratePopup": {
      "shareOrEmbed": "Incorpora o condividi il modulo",
      "share": {
        "openFormLink": "Apri il Link Modulo"
      },
      "email": {
        "emailSubheader": "Crea Email vuota e incorpora il tuo modulo, o seleziona un modello e incorporalo immediatamente."
      }
    },
    "choosePosition": "Seleziona Stato",
    "testBuild": "Test di build"
  },
  "quiz": {
    "quizElement": "Elemento del quiz",
    "quizNotification": "Notifica quiz",
    "viewAndCustomise": "Visualizza e personalizza",
    "categoryAndScore": "Categoria e punteggio",
    "provideFeedback": "Fornisci un feedback",
    "addQuizElement": "Aggiungi elemento quiz",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Aggiungi domande",
    "dragAndDropQuestion": "Trascina un elemento Domanda qui.",
    "addNewPage": "Aggiungi Pagina",
    "editTemplate": "Modifica Modello",
    "editResultPage": "Modifica pagina dei risultati",
    "clonePage": "Clona Pagina",
    "category": {
      "category": "Categoria",
      "useCategoryWhen": "Usa categorie quando",
      "manageCategories": "Gestisci Categorie",
      "howItWorks2": "Come funziona",
      "addCategoryMessage": "Aggiungi una nuova categoria",
      "assignCategoryMessage": "Assegna una categoria a ogni opzione",
      "editResultsMessage": "Punteggio Mostra Categoria in Risultato Pagina",
      "toEvaluateTheResponder": "Per confrontare il risponditore Attivo ha basato diversi fattori",
      "showMultipleCategoryScore": "Mostra il punteggio di Mostra multipla categoria in Risultato Pagina",
      "displayVaryingContent": "Visualizzazione variabile Contenuti Attivo i risultati Pagina dipende dalla categoria di punteggio di Attivo",
      "addManage": "Aggiungi / Gestisci",
      "carouselAlt": "Diapositiva di anteprima della categoria"
    },
    "quizSettings": "Impostazioni del quiz",
    "saveExitConfirmation": "Salva l'avanzamento per i quiz",
    "onQuizSubmission": "All'invio del quiz",
    "settings": "Impostazioni",
    "deletePage": "Elimina pagina",
    "quizResult": {
      "resultTemplate": "Modello di pagina dei risultati",
      "quizResultAlertMessage": "La pagina dei risultati scelta verrà mostrata una volta completato il quiz",
      "overallScoreLabel": "Punteggio complessivo",
      "resultTemplateAlt": "Anteprima del modello dei risultati del quiz"
    },
    "deleteSlideMessage": "Vuoi davvero eliminare questa diapositiva?",
    "autoResponderSubheader": "Invia un'e-mail automatica alla persona che invia il quiz (l'e-mail include una copia delle informazioni inserite nel quiz)",
    "sendSubmissionsAsPdf": "Invia l'invio del quiz come PDF",
    "sendQuizResultsAsPdf": "Invia il risultato del quiz come PDF",
    "integrateHeader": "Integra quiz",
    "integrateSubHeader": "Usa le seguenti opzioni per integrare il tuo quiz personalizzato nel tuo sito web",
    "integrateCopyLinkMessage": "Copia il link qui sotto e condividilo facilmente ovunque desideri.",
    "pageLabel": "Pagina {n}",
    "pageName": "Nome della pagina",
    "pagePosition": "Posizione della pagina",
    "createContactOnPartialSubmissionSubText": "Crea un contatto quando un utente fa clic su \"Avanti\" su qualsiasi diapositiva, anche se non completa il quiz.",
    "integratePopup": {
      "shareOrEmbed": "Incorpora o Condividi Quiz",
      "share": {
        "openFormLink": "Apri il Link del quiz"
      },
      "email": {
        "emailSubheader": "Crea Email vuota e incorpora il tuo quiz, o seleziona un modello e incorporalo immediatamente."
      }
    }
  },
  "integrate": {
    "embed": {
      "chooseType": "Scegli tipo",
      "sidebar": "Barra laterale",
      "popover": "Popover",
      "popup": "Popup",
      "standard": "Standard",
      "formWidth": "Larghezza del modulo",
      "formHeight": "Altezza del modulo",
      "showLauncher": "Mostra il pulsante {asset}",
      "showLauncherHelp": "I visitatori possono ridurre a icona e riaprire il {asset} in qualsiasi momento.",
      "position": "Scegli la posizione",
      "left": "Sinistra",
      "right": "Destra",
      "buttonLabel": "Etichetta del pulsante",
      "buttonColor": "Colore del pulsante",
      "buttonType": "Tipo di pulsante",
      "buttonSize": "Dimensione del pulsante",
      "text": "Testo",
      "iconAndText": "Icona + testo",
      "iconOnly": "Solo icona",
      "small": "Piccolo",
      "medium": "Medio",
      "large": "Grande",
      "icon": "Icona",
      "cornerRadius": "Raggio d'angolo",
      "linkCornerRadius": "Collega i valori del raggio d'angolo",
      "corner": {
        "tl": "Raggio d'angolo in alto a sinistra",
        "tr": "Raggio dell'angolo in alto a destra",
        "bl": "Raggio dell'angolo in basso a sinistra",
        "br": "Raggio dell'angolo in basso a destra"
      },
      "fontSize": "Dimensione del carattere",
      "embedIn": "Incorpora in",
      "funnels": "Funnel",
      "websites": "Siti web",
      "settingsTitle": "Impostazioni di incorporamento",
      "preview": "Anteprima",
      "previewHint": "Premi il pulsante per vedere il tuo {type} in azione",
      "realPreviewTitle": "Anteprima del tuo {asset}",
      "realPreviewUnavailable": "Anteprima live non disponibile. Viene mostrato invece un esempio.",
      "ghostName": "Nome",
      "ghostNamePlaceholder": "Inserisci il tuo nome",
      "ghostPhone": "Numero di telefono",
      "ghostPhonePlaceholder": "+39 334 123 4567",
      "ghostEmail": "Indirizzo email",
      "ghostEmailPlaceholder": "esempio{'@'}gmail.com",
      "ghostSubmit": "Invia",
      "sidebarLower": "barra laterale",
      "popoverLower": "popover",
      "popupLower": "popup",
      "standardLower": "modulo standard",
      "general": "Generale",
      "advanced": "Avanzato",
      "embedCode": "Incorpora codice",
      "triggerType": "Tipo di trigger",
      "alwaysShow": "Mostra sempre",
      "showAfter": "Mostra dopo",
      "showOnScrolling": "Mostra su scorrimento",
      "activation": "Opzioni di attivazione",
      "alwaysActivated": "Sempre attivato",
      "activateOnVisit": "Attiva alla visita",
      "deactivation": "Opzioni di disattivazione",
      "neverDeactivate": "Non disattivare mai",
      "deactivateAfter": "Disattiva dopo la visualizzazione",
      "leadCollected": "Una volta raccolto un lead",
      "modalTitle": "Incorpora nella pagina web",
      "copyStep": "Copia il codice di incorporamento",
      "openWebpageStep": "Apri la tua pagina web",
      "openWebpageStepHelp": "Apra l'editor di pagina e trovi l'opzione per aggiungere HTML o codice personalizzato.",
      "publishStep": "Incolla il codice e pubblica",
      "publishStepHelp": "Incolla il codice di incorporamento nella sezione HTML o del codice personalizzato, quindi salva e pubblica la tua pagina.",
      "copyCode": "Copia codice",
      "setupGuidePrompt": "Sta utilizzando WordPress, Wix o Webflow?",
      "viewSetupGuides": "Visualizza le guide alla configurazione"
    },
    "postSave": {
      "title": "Il suo {asset} è pronto",
      "description": "Condividilo, incorporalo, o collega un flusso di lavoro quando sei pronto.",
      "embedForm": "Incorpora {asset}",
      "connect": "Collega",
      "createWorkflow": "Crea un flusso di lavoro",
      "workflowDescription": "Esegui un flusso di lavoro per ogni invio.",
      "dontShowAgain": "Non mostrarlo più"
    },
    "email": {
      "preview": "Anteprima",
      "shareViaEmail": "Condividi tramite email",
      "startFromScratch": "Inizia da zero",
      "emailMarketingTemplates": "Modelli di email marketing",
      "templateImageAlt": "2000+ modelli di email",
      "yourTemplates": "I tuoi modelli",
      "selectTemplate": "Seleziona dai tuoi modelli",
      "to": "A:",
      "from": "Da:",
      "inviteTitle": "Salve,",
      "inviteBody": "Ti ho invitato a compilare un modulo:",
      "inviteAction": "Compila il nostro modulo"
    },
    "share": {
      "copyLink": "Condividi il link",
      "copyLinkTitle": "Copia il link al tuo {asset}",
      "copyLinkDescription": "Inizia a raccogliere gli invii per il tuo {asset}. Che tu voglia condividere il link o incorporarlo da qualche parte, abbiamo quello che fa per te.",
      "copyLinkButton": "Copia link",
      "openLink": "Apri link",
      "shareOnSocialMedia": "Condividi sui social media",
      "socialDescription": "Condividi facilmente il tuo {asset} sulle piattaforme di social media che preferisci e inizia a raccogliere gli invii.",
      "qrCode": "Codice QR",
      "shareQr": "Condividi il codice QR",
      "shareQrDescription": "Scansiona o condividi questo codice QR per accedere subito al tuo {asset}.",
      "qrLoading": "Caricamento del codice QR...",
      "qrLoadError": "Impossibile caricare il codice QR. Riprova.",
      "preview": "Anteprima",
      "social": {
        "facebook": "Condividi su Facebook",
        "whatsapp": "Condividi su WhatsApp",
        "linkedin": "Condividi su LinkedIn",
        "x": "Condividi su X"
      }
    }
  },
  "textEditor": {
    "textAlign": "Allineamento del testo",
    "list": "Elenco",
    "sourceCode": "Codice sorgente",
    "resetStyle": "Ripristina stile",
    "resetDocumentStyle": "Reimpostare lo stile del documento"
  },
  "builderValidation": {
    "ui": {
      "checking": "Corrente",
      "actionRequired": "Azione richiesta",
      "errorSummary": "Devi correggere {n} errori prima di poter salvare. Selezionalo per passare all'errore.",
      "viewErrors": "Visualizza errori",
      "panelTitle": "Consigli ({n})",
      "panelSubtitle": "Suggerimenti facoltativi per migliorare il tuo {product}. Salva in qualsiasi momento.",
      "tabRecommendations": "Consigli",
      "tabInsights": "Approfondimenti",
      "recommendationsPill": "Consigli",
      "noRecommendationsTitle": "Niente da esaminare",
      "noRecommendationsBody": "Questo {product} non ha consigli. È tutto pronto per salvare.",
      "settingTitle": "Mostra {product} consigli",
      "settingDescription": "Ricevi consigli intelligenti per individuare errori passati inosservati, migliorare il tuo {product} e aumentare gli invii",
      "dontShowAgain": "Non mostrare più",
      "allClearTitle": "Tutto chiaro",
      "allClearBody": "È tutto risolto. Sei pronto a salvare.",
      "openInsight": "Apri le impostazioni di {name}",
      "dontShowAgainHint": "I suggerimenti per i moduli verranno disattivati, ma puoi attivarli in qualsiasi momento dalla scheda Impostazioni.",
      "panelLabel": "Consigli"
    },
    "errors": {
      "urlFieldDomainsMissing": "Un campo URL limita i domini, ma non ne è elencato nessuno.",
      "pictureChoiceImageMissing": "Un'opzione a scelta con immagini non ha un'immagine.",
      "pictureChoiceLabelMissing": "Un'opzione di scelta con immagine non ha etichetta.",
      "pictureChoiceDuplicateLabels": "Due opzioni di scelta con immagini hanno la stessa etichetta.",
      "pictureChoiceSelectionLimitInvalid": "Un limite di selezione della scelta con immagini è superiore al numero di opzioni.",
      "datetimeLabelEmpty": "Un campo data e ora non ha un'etichetta.",
      "datetimeTimeFormatInvalid": "Un campo data e ora ha un orario predefinito non valido.",
      "datetimeNoAvailableDays": "Un campo data e ora non ha giorni disponibili da selezionare.",
      "datetimeDateRangeInvalid": "Un campo data e ora ha un intervallo di date incompleto o invertito.",
      "datetimeTimeRangeInvalid": "Un campo data e ora ha un intervallo di tempo incompleto o invertito.",
      "opportunitySettingsIncomplete": "Questo modulo raccoglie i campi dell'opportunità, ma non è stata impostata alcuna fase della sequenza.",
      "footerStylesInvalid": "Le impostazioni del piè di pagina sono incomplete.",
      "emptyCustomFieldLabel": "Un campo personalizzato non ha etichetta.",
      "duplicateCustomFieldName": "Due campi condividono l'etichetta \"{name}.\"",
      "sellProductsNoProduct": "Un elemento prodotto non contiene prodotti né prodotti aggiuntivi.",
      "imageMissing": "Un elemento immagine non ha un'immagine.",
      "scoreCalculationEmpty": "Un elemento del punteggio non ha campi nel suo calcolo."
    },
    "errorsInline": {
      "urlFieldDomainsMissing": "Nessun dominio aggiunto",
      "pictureChoiceImageMissing": "Nessuna immagine aggiunta",
      "pictureChoiceLabelMissing": "Etichetta mancante",
      "pictureChoiceDuplicateLabels": "Etichetta duplicata",
      "pictureChoiceSelectionLimitInvalid": "Limite di selezione non valido",
      "datetimeLabelEmpty": "Etichetta mancante",
      "datetimeTimeFormatInvalid": "Ora non valida",
      "datetimeNoAvailableDays": "Nessun giorno selezionato",
      "datetimeDateRangeInvalid": "Intervallo di date non valido",
      "datetimeTimeRangeInvalid": "Intervallo di tempo non valido",
      "opportunitySettingsIncomplete": "Fase della sequenza mancante",
      "footerStylesInvalid": "Impostazioni del piè di pagina incomplete",
      "emptyCustomFieldLabel": "Etichetta mancante",
      "duplicateCustomFieldName": "Etichetta duplicata",
      "sellProductsNoProduct": "Nessun prodotto aggiunto",
      "imageMissing": "Nessuna immagine aggiunta",
      "scoreCalculationEmpty": "Nessun campo aggiunto"
    },
    "errorsAction": {
      "urlFieldDomainsMissing": "Aggiungi un dominio",
      "pictureChoiceImageMissing": "Aggiungi immagine",
      "pictureChoiceLabelMissing": "Aggiungi un'etichetta",
      "pictureChoiceDuplicateLabels": "Rinomina etichetta duplicata",
      "pictureChoiceSelectionLimitInvalid": "Correggi il limite di selezione",
      "datetimeLabelEmpty": "Aggiungi un'etichetta",
      "datetimeTimeFormatInvalid": "Correggi l'orario predefinito",
      "datetimeNoAvailableDays": "Seleziona i giorni disponibili",
      "datetimeDateRangeInvalid": "Correggi l’intervallo di date",
      "datetimeTimeRangeInvalid": "Correggi intervallo di tempo",
      "opportunitySettingsIncomplete": "Apri le impostazioni delle opportunità",
      "footerStylesInvalid": "Apri le impostazioni del piè di pagina",
      "emptyCustomFieldLabel": "Aggiungi un'etichetta",
      "duplicateCustomFieldName": "Rinomina etichetta duplicata",
      "sellProductsNoProduct": "Aggiungi prodotti",
      "imageMissing": "Aggiungi immagine",
      "scoreCalculationEmpty": "Aggiungi campi"
    },
    "recommendations": {
      "termsConditionsMissing": "Raccogli il consenso prima di archiviare i dati dei visitatori.",
      "captchaMissing": "Proteggi questo modulo dagli invii di spam.",
      "privacyPolicyUrlMissing": "Il testo di consenso continua a rimandare a example.com.",
      "sellProductsNotLive": "Il pagamento è in modalità test, quindi non verrà riscosso denaro.",
      "defaultCustomFieldName": "Le etichette predefinite rendono gli invii difficili da leggere.",
      "emptyCustomFieldLabelExisting": "Un campo non ha un'etichetta, quindi i visitatori non sapranno cosa inserire.",
      "quizOptionPlaceholder": "Risposte in \"{label}\" utilizzano ancora i nomi predefiniti delle opzioni.",
      "quizScoreBlank": "Una risposta non ha un punteggio, quindi non verrà conteggiata ai fini di un risultato.",
      "quizCtaUrlMissing": "Il pulsante della pagina dei risultati non ha una destinazione.",
      "quizCtaUrlPlaceholder": "Il pulsante della pagina dei risultati rimanda ancora a example.com.",
      "headerTextEmpty": "Un elemento di testo è vuoto.",
      "htmlElementEmpty": "Un elemento HTML non contiene contenuti.",
      "buttonTextEmpty": "Il pulsante di invio non contiene testo.",
      "sourceFieldValueEmpty": "Un campo sorgente nascosto non ha alcun valore, quindi non viene tracciato nulla.",
      "optionLabelEmpty": "Un'opzione di risposta non ha etichetta.",
      "fileUploadMaxSizeInvalid": "Il limite di caricamento dei file non è un numero valido.",
      "submitRedirectUrlMissing": "Gli invii reindirizzano da qualche parte, ma non è impostato alcun indirizzo.",
      "submitRedirectUrlInvalid": "L'indirizzo di reindirizzamento dopo l'invio non è un URL valido.",
      "disqualifyUrlMissing": "I visitatori non idonei vengono reindirizzati, ma non è impostato alcun indirizzo.",
      "disqualifyMessageEmpty": "Ai visitatori squalificati viene mostrato un messaggio vuoto.",
      "scheduleRedirectUrlInvalid": "Un indirizzo di reindirizzamento programmato non è un URL valido.",
      "scheduleNoClosedStateContent": "Uno stato programmato non mostra nulla ai visitatori.",
      "notificationRecipientMissing": "Le notifiche email sono attive senza destinatari a cui inviarle.",
      "notificationEmailInvalid": "Un destinatario della notifica non è un indirizzo email valido.",
      "logicOrphanFieldReference": "Una regola logica fa riferimento a un campo che non esiste più, quindi non viene mai eseguita.",
      "logicOrphanOptionReference": "Una regola logica punta a un'opzione di risposta che non esiste più.",
      "logicOrphanTarget": "Una regola logica porta a una pagina che non esiste più.",
      "scoreCalculationInvalidReference": "Un calcolo del punteggio utilizza un campo che non esiste più.",
      "assetHasNoElements": "Non è stata ancora aggiunta alcuna domanda, quindi non c'è nulla da raccogliere."
    },
    "recommendationsAction": {
      "termsConditionsMissing": "Aggiungi il campo Termini e condizioni",
      "captchaMissing": "Aggiungi la protezione dai bot",
      "privacyPolicyUrlMissing": "Aggiorna i link",
      "sellProductsNotLive": "Attiva la modalità live",
      "defaultCustomFieldName": "Rinomina \"{label}\"",
      "emptyCustomFieldLabelExisting": "Aggiungi un'etichetta",
      "quizOptionPlaceholder": "Rinomina le opzioni",
      "quizScoreBlank": "Aggiungi un punteggio",
      "quizCtaUrlMissing": "Aggiungi un link",
      "quizCtaUrlPlaceholder": "Aggiorna il link",
      "headerTextEmpty": "Aggiungi testo",
      "htmlElementEmpty": "Aggiungi contenuto",
      "buttonTextEmpty": "Aggiungi il testo del pulsante",
      "sourceFieldValueEmpty": "Aggiungi un valore",
      "optionLabelEmpty": "Aggiungi un'etichetta",
      "fileUploadMaxSizeInvalid": "Imposta un limite",
      "submitRedirectUrlMissing": "Aggiungi un URL di reindirizzamento",
      "submitRedirectUrlInvalid": "Correggi l'URL di reindirizzamento",
      "disqualifyUrlMissing": "Aggiungi un URL di reindirizzamento",
      "disqualifyMessageEmpty": "Aggiungi un messaggio",
      "scheduleRedirectUrlInvalid": "Correggi l'URL di reindirizzamento",
      "scheduleNoClosedStateContent": "Aggiungi contenuto",
      "notificationRecipientMissing": "Aggiungi un destinatario",
      "notificationEmailInvalid": "Corregga l'indirizzo",
      "logicOrphanFieldReference": "Logica di revisione",
      "logicOrphanOptionReference": "Logica di revisione",
      "logicOrphanTarget": "Logica di revisione",
      "scoreCalculationInvalidReference": "Correggi il calcolo",
      "assetHasNoElements": "Aggiungi la tua prima domanda"
    },
    "insights": {
      "heading": "La configurazione del tuo modulo in sintesi.",
      "conditionalLogic": "Logica condizionale",
      "submitDestination": "Azione all'invio",
      "customFields": "Campi personalizzati",
      "paymentMode": "Modalità di pagamento",
      "emailNotification": "Notifiche email",
      "autoResponder": "Risponditore automatico",
      "quizCategories": "Categorie dei quiz",
      "ruleCount": "{n} regole",
      "on": "Attivo",
      "off": "Disattivato",
      "live": "Live",
      "test": "Test",
      "destinationUrl": "URL di reindirizzamento",
      "destinationMessage": "Messaggio",
      "destinationOrder": "Conferma dell'ordine",
      "destinationQuizResult": "Risultato del quiz"
    },
    "groups": {
      "fields": "Campi",
      "questions": "Domande",
      "questionsPage": "Pagina delle domande",
      "resultsPage": "Pagina dei risultati",
      "payments": "Pagamenti",
      "settings": "Impostazioni"
    }
  }
}
